import { cabinetApi as api } from "../api";
export const addTagTypes = [
  "CalendarEvent",
  "api",
  "ExternalMeeting",
  "MeetingLocationPresetViewset",
  "MeetingSlotCalendarEvent",
  "MeetingTemplateViewset",
  "Meeting",
  "PinnedCalendar",
  "SchedulingPreferences",
  "ZoomUser",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      appSchedulingCalendarEventsList: build.query<
        AppSchedulingCalendarEventsListApiResponse,
        AppSchedulingCalendarEventsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendar-events/`,
          params: {
            endDate: queryArg.endDate,
            forTimezone: queryArg.forTimezone,
            googleCalId: queryArg.googleCalId,
            limit: queryArg.limit,
            msCalId: queryArg.msCalId,
            offset: queryArg.offset,
            startDate: queryArg.startDate,
          },
        }),
        providesTags: ["CalendarEvent"],
      }),
      appSchedulingCalendarEventsRetrieve: build.query<
        AppSchedulingCalendarEventsRetrieveApiResponse,
        AppSchedulingCalendarEventsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendar-events/${queryArg}/`,
        }),
        providesTags: ["CalendarEvent"],
      }),
      appSchedulingCalendarEventsPartialUpdate: build.mutation<
        AppSchedulingCalendarEventsPartialUpdateApiResponse,
        AppSchedulingCalendarEventsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendar-events/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedCalendarEvent,
        }),
        invalidatesTags: ["CalendarEvent"],
      }),
      appSchedulingCalendarEventsDestroy: build.mutation<
        AppSchedulingCalendarEventsDestroyApiResponse,
        AppSchedulingCalendarEventsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendar-events/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["CalendarEvent"],
      }),
      appSchedulingCalendarsList: build.query<
        AppSchedulingCalendarsListApiResponse,
        AppSchedulingCalendarsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendars/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appSchedulingCalendarsCreate: build.mutation<
        AppSchedulingCalendarsCreateApiResponse,
        AppSchedulingCalendarsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendars/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingCalendarsRetrieve: build.query<
        AppSchedulingCalendarsRetrieveApiResponse,
        AppSchedulingCalendarsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendars/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appSchedulingCalendarsUpdate: build.mutation<
        AppSchedulingCalendarsUpdateApiResponse,
        AppSchedulingCalendarsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendars/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.calendarRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingCalendarsPartialUpdate: build.mutation<
        AppSchedulingCalendarsPartialUpdateApiResponse,
        AppSchedulingCalendarsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendars/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedCalendar,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingCalendarsDestroy: build.mutation<
        AppSchedulingCalendarsDestroyApiResponse,
        AppSchedulingCalendarsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendars/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingCalendarsBatchAssociateCreate: build.mutation<
        AppSchedulingCalendarsBatchAssociateCreateApiResponse,
        AppSchedulingCalendarsBatchAssociateCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendars/batch-associate/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingCalendarsGetCalendarByEmailCreate: build.mutation<
        AppSchedulingCalendarsGetCalendarByEmailCreateApiResponse,
        AppSchedulingCalendarsGetCalendarByEmailCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/calendars/get-calendar-by-email/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingCalendarsSyncCalendarColorsRetrieve: build.query<
        AppSchedulingCalendarsSyncCalendarColorsRetrieveApiResponse,
        AppSchedulingCalendarsSyncCalendarColorsRetrieveApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-scheduling/calendars/sync-calendar-colors/`,
        }),
        providesTags: ["api"],
      }),
      appSchedulingCalendarsUpdateAdditionalCalendarPartialUpdate:
        build.mutation<
          AppSchedulingCalendarsUpdateAdditionalCalendarPartialUpdateApiResponse,
          AppSchedulingCalendarsUpdateAdditionalCalendarPartialUpdateApiArg
        >({
          query: (queryArg) => ({
            url: `/api/v1_15/app-scheduling/calendars/update-additional-calendar/`,
            method: "PATCH",
            body: queryArg,
          }),
          invalidatesTags: ["api"],
        }),
      appSchedulingExternalMeetingsBookExternalCreate: build.mutation<
        AppSchedulingExternalMeetingsBookExternalCreateApiResponse,
        AppSchedulingExternalMeetingsBookExternalCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/external-meetings/book-external/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ExternalMeeting"],
      }),
      appSchedulingExternalMeetingsCancelExternalCreate: build.mutation<
        AppSchedulingExternalMeetingsCancelExternalCreateApiResponse,
        AppSchedulingExternalMeetingsCancelExternalCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/external-meetings/cancel-external/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ExternalMeeting"],
      }),
      appSchedulingExternalMeetingsGetExternalRetrieve: build.query<
        AppSchedulingExternalMeetingsGetExternalRetrieveApiResponse,
        AppSchedulingExternalMeetingsGetExternalRetrieveApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-scheduling/external-meetings/get-external/`,
        }),
        providesTags: ["ExternalMeeting"],
      }),
      appSchedulingLeaderCalendarsList: build.query<
        AppSchedulingLeaderCalendarsListApiResponse,
        AppSchedulingLeaderCalendarsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/leader-calendars/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appSchedulingLeaderCalendarsCreate: build.mutation<
        AppSchedulingLeaderCalendarsCreateApiResponse,
        AppSchedulingLeaderCalendarsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/leader-calendars/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingLeaderCalendarsRetrieve: build.query<
        AppSchedulingLeaderCalendarsRetrieveApiResponse,
        AppSchedulingLeaderCalendarsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/leader-calendars/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appSchedulingLeaderCalendarsUpdate: build.mutation<
        AppSchedulingLeaderCalendarsUpdateApiResponse,
        AppSchedulingLeaderCalendarsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/leader-calendars/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.leaderCalendarRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingLeaderCalendarsPartialUpdate: build.mutation<
        AppSchedulingLeaderCalendarsPartialUpdateApiResponse,
        AppSchedulingLeaderCalendarsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/leader-calendars/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedLeaderCalendar,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingLeaderCalendarsDestroy: build.mutation<
        AppSchedulingLeaderCalendarsDestroyApiResponse,
        AppSchedulingLeaderCalendarsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/leader-calendars/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingAuditLogsList: build.query<
        AppSchedulingMeetingAuditLogsListApiResponse,
        AppSchedulingMeetingAuditLogsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-audit-logs/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appSchedulingMeetingExternalParticipantsList: build.query<
        AppSchedulingMeetingExternalParticipantsListApiResponse,
        AppSchedulingMeetingExternalParticipantsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-external-participants/`,
          params: {
            limit: queryArg.limit,
            meeting_external_id: queryArg.meetingExternalId,
            offset: queryArg.offset,
            preregistered: queryArg.preregistered,
          },
        }),
        providesTags: ["api"],
      }),
      appSchedulingMeetingExternalParticipantsCreate: build.mutation<
        AppSchedulingMeetingExternalParticipantsCreateApiResponse,
        AppSchedulingMeetingExternalParticipantsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-external-participants/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingExternalParticipantsUpdate: build.mutation<
        AppSchedulingMeetingExternalParticipantsUpdateApiResponse,
        AppSchedulingMeetingExternalParticipantsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-external-participants/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.meetingParticipantRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingExternalParticipantsPartialUpdate: build.mutation<
        AppSchedulingMeetingExternalParticipantsPartialUpdateApiResponse,
        AppSchedulingMeetingExternalParticipantsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-external-participants/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedMeetingParticipant,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingExternalParticipantsDestroy: build.mutation<
        AppSchedulingMeetingExternalParticipantsDestroyApiResponse,
        AppSchedulingMeetingExternalParticipantsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-external-participants/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingExternalParticipantsNoTimesWorkCreate: build.mutation<
        AppSchedulingMeetingExternalParticipantsNoTimesWorkCreateApiResponse,
        AppSchedulingMeetingExternalParticipantsNoTimesWorkCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-external-participants/no-times-work/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingFilesDestroy: build.mutation<
        AppSchedulingMeetingFilesDestroyApiResponse,
        AppSchedulingMeetingFilesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-files/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingLeadersList: build.query<
        AppSchedulingMeetingLeadersListApiResponse,
        AppSchedulingMeetingLeadersListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-leaders/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appSchedulingMeetingLeadersCreate: build.mutation<
        AppSchedulingMeetingLeadersCreateApiResponse,
        AppSchedulingMeetingLeadersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-leaders/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingLeadersRetrieve: build.query<
        AppSchedulingMeetingLeadersRetrieveApiResponse,
        AppSchedulingMeetingLeadersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-leaders/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appSchedulingMeetingLeadersUpdate: build.mutation<
        AppSchedulingMeetingLeadersUpdateApiResponse,
        AppSchedulingMeetingLeadersUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-leaders/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.meetingLeaderRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingLeadersPartialUpdate: build.mutation<
        AppSchedulingMeetingLeadersPartialUpdateApiResponse,
        AppSchedulingMeetingLeadersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-leaders/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedMeetingLeader,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingLeadersDestroy: build.mutation<
        AppSchedulingMeetingLeadersDestroyApiResponse,
        AppSchedulingMeetingLeadersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-leaders/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingLeadersBulkUpdateOrCreateCreate: build.mutation<
        AppSchedulingMeetingLeadersBulkUpdateOrCreateCreateApiResponse,
        AppSchedulingMeetingLeadersBulkUpdateOrCreateCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-leaders/bulk-update-or-create/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingLocationPresetsList: build.query<
        AppSchedulingMeetingLocationPresetsListApiResponse,
        AppSchedulingMeetingLocationPresetsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-location-presets/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["MeetingLocationPresetViewset"],
      }),
      appSchedulingMeetingLocationPresetsCreate: build.mutation<
        AppSchedulingMeetingLocationPresetsCreateApiResponse,
        AppSchedulingMeetingLocationPresetsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-location-presets/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["MeetingLocationPresetViewset"],
      }),
      appSchedulingMeetingLocationPresetsRetrieve: build.query<
        AppSchedulingMeetingLocationPresetsRetrieveApiResponse,
        AppSchedulingMeetingLocationPresetsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-location-presets/${queryArg}/`,
        }),
        providesTags: ["MeetingLocationPresetViewset"],
      }),
      appSchedulingMeetingLocationPresetsUpdate: build.mutation<
        AppSchedulingMeetingLocationPresetsUpdateApiResponse,
        AppSchedulingMeetingLocationPresetsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-location-presets/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.meetingLocationPresetRequest,
        }),
        invalidatesTags: ["MeetingLocationPresetViewset"],
      }),
      appSchedulingMeetingLocationPresetsPartialUpdate: build.mutation<
        AppSchedulingMeetingLocationPresetsPartialUpdateApiResponse,
        AppSchedulingMeetingLocationPresetsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-location-presets/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedMeetingLocationPreset,
        }),
        invalidatesTags: ["MeetingLocationPresetViewset"],
      }),
      appSchedulingMeetingLocationPresetsDestroy: build.mutation<
        AppSchedulingMeetingLocationPresetsDestroyApiResponse,
        AppSchedulingMeetingLocationPresetsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-location-presets/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["MeetingLocationPresetViewset"],
      }),
      appSchedulingMeetingPollSelectionsList: build.query<
        AppSchedulingMeetingPollSelectionsListApiResponse,
        AppSchedulingMeetingPollSelectionsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-poll-selections/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appSchedulingMeetingPollSelectionsCreate: build.mutation<
        AppSchedulingMeetingPollSelectionsCreateApiResponse,
        AppSchedulingMeetingPollSelectionsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-poll-selections/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingPollSelectionsBulkUpdatePollSelectionsPartialUpdate:
        build.mutation<
          AppSchedulingMeetingPollSelectionsBulkUpdatePollSelectionsPartialUpdateApiResponse,
          AppSchedulingMeetingPollSelectionsBulkUpdatePollSelectionsPartialUpdateApiArg
        >({
          query: (queryArg) => ({
            url: `/api/v1_15/app-scheduling/meeting-poll-selections/bulk-update-poll-selections/`,
            method: "PATCH",
            body: queryArg,
          }),
          invalidatesTags: ["api"],
        }),
      appSchedulingMeetingPollSelectionsDeletePollSelectionsCreate:
        build.mutation<
          AppSchedulingMeetingPollSelectionsDeletePollSelectionsCreateApiResponse,
          AppSchedulingMeetingPollSelectionsDeletePollSelectionsCreateApiArg
        >({
          query: (queryArg) => ({
            url: `/api/v1_15/app-scheduling/meeting-poll-selections/delete-poll-selections/`,
            method: "POST",
            body: queryArg,
          }),
          invalidatesTags: ["api"],
        }),
      appSchedulingMeetingQuestionAnswersGetByMeetingsRetrieve: build.query<
        AppSchedulingMeetingQuestionAnswersGetByMeetingsRetrieveApiResponse,
        AppSchedulingMeetingQuestionAnswersGetByMeetingsRetrieveApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-scheduling/meeting-question-answers/get-by-meetings/`,
        }),
        providesTags: ["api"],
      }),
      appSchedulingMeetingQuestionAnswersGetExternalMeetingAnswersRetrieve:
        build.query<
          AppSchedulingMeetingQuestionAnswersGetExternalMeetingAnswersRetrieveApiResponse,
          AppSchedulingMeetingQuestionAnswersGetExternalMeetingAnswersRetrieveApiArg
        >({
          query: () => ({
            url: `/api/v1_15/app-scheduling/meeting-question-answers/get-external-meeting-answers/`,
          }),
          providesTags: ["api"],
        }),
      appSchedulingMeetingQuestionAnswersSubmitAnswersCreate: build.mutation<
        AppSchedulingMeetingQuestionAnswersSubmitAnswersCreateApiResponse,
        AppSchedulingMeetingQuestionAnswersSubmitAnswersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-question-answers/submit-answers/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingQuestionsCreate: build.mutation<
        AppSchedulingMeetingQuestionsCreateApiResponse,
        AppSchedulingMeetingQuestionsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-questions/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingQuestionsUpdate: build.mutation<
        AppSchedulingMeetingQuestionsUpdateApiResponse,
        AppSchedulingMeetingQuestionsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-questions/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.readMeetingQuestionRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingQuestionsPartialUpdate: build.mutation<
        AppSchedulingMeetingQuestionsPartialUpdateApiResponse,
        AppSchedulingMeetingQuestionsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-questions/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedReadMeetingQuestion,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingQuestionsDestroy: build.mutation<
        AppSchedulingMeetingQuestionsDestroyApiResponse,
        AppSchedulingMeetingQuestionsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-questions/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingQuestionsSubmitQuestionsCreate: build.mutation<
        AppSchedulingMeetingQuestionsSubmitQuestionsCreateApiResponse,
        AppSchedulingMeetingQuestionsSubmitQuestionsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-questions/submit-questions/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingRoomsList: build.query<
        AppSchedulingMeetingRoomsListApiResponse,
        AppSchedulingMeetingRoomsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-rooms/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appSchedulingMeetingSlotCalendarEventsUpdate: build.mutation<
        AppSchedulingMeetingSlotCalendarEventsUpdateApiResponse,
        AppSchedulingMeetingSlotCalendarEventsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-slot-calendar-events/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.meetingSlotCalendarEventRequest,
        }),
        invalidatesTags: ["MeetingSlotCalendarEvent"],
      }),
      appSchedulingMeetingSlotCalendarEventsPartialUpdate: build.mutation<
        AppSchedulingMeetingSlotCalendarEventsPartialUpdateApiResponse,
        AppSchedulingMeetingSlotCalendarEventsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-slot-calendar-events/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedMeetingSlotCalendarEvent,
        }),
        invalidatesTags: ["MeetingSlotCalendarEvent"],
      }),
      appSchedulingMeetingSlotCalendarEventsDestroy: build.mutation<
        AppSchedulingMeetingSlotCalendarEventsDestroyApiResponse,
        AppSchedulingMeetingSlotCalendarEventsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-slot-calendar-events/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["MeetingSlotCalendarEvent"],
      }),
      appSchedulingMeetingSlotCalendarEventsMeetingErrorsRetrieve: build.query<
        AppSchedulingMeetingSlotCalendarEventsMeetingErrorsRetrieveApiResponse,
        AppSchedulingMeetingSlotCalendarEventsMeetingErrorsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-slot-calendar-events/meeting-errors/`,
          params: {
            meetingId: queryArg.meetingId,
            unscheduled: queryArg.unscheduled,
          },
        }),
        providesTags: ["MeetingSlotCalendarEvent"],
      }),
      appSchedulingMeetingSlotsList: build.query<
        AppSchedulingMeetingSlotsListApiResponse,
        AppSchedulingMeetingSlotsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-slots/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appSchedulingMeetingSlotsCreate: build.mutation<
        AppSchedulingMeetingSlotsCreateApiResponse,
        AppSchedulingMeetingSlotsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-slots/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingSlotsRetrieve: build.query<
        AppSchedulingMeetingSlotsRetrieveApiResponse,
        AppSchedulingMeetingSlotsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-slots/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appSchedulingMeetingSlotsUpdate: build.mutation<
        AppSchedulingMeetingSlotsUpdateApiResponse,
        AppSchedulingMeetingSlotsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-slots/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.meetingSlotRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingSlotsPartialUpdate: build.mutation<
        AppSchedulingMeetingSlotsPartialUpdateApiResponse,
        AppSchedulingMeetingSlotsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-slots/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedMeetingSlot,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingSlotsDestroy: build.mutation<
        AppSchedulingMeetingSlotsDestroyApiResponse,
        AppSchedulingMeetingSlotsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-slots/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingSlotsBulkCreateCreate: build.mutation<
        AppSchedulingMeetingSlotsBulkCreateCreateApiResponse,
        AppSchedulingMeetingSlotsBulkCreateCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-slots/bulk-create/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingSlotsBulkDeleteDestroy: build.mutation<
        AppSchedulingMeetingSlotsBulkDeleteDestroyApiResponse,
        AppSchedulingMeetingSlotsBulkDeleteDestroyApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-scheduling/meeting-slots/bulk-delete/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingMeetingTemplatesList: build.query<
        AppSchedulingMeetingTemplatesListApiResponse,
        AppSchedulingMeetingTemplatesListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-scheduling/meeting-templates/` }),
        providesTags: ["MeetingTemplateViewset"],
      }),
      appSchedulingMeetingTemplatesCreate: build.mutation<
        AppSchedulingMeetingTemplatesCreateApiResponse,
        AppSchedulingMeetingTemplatesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-templates/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["MeetingTemplateViewset"],
      }),
      appSchedulingMeetingTemplatesRetrieve: build.query<
        AppSchedulingMeetingTemplatesRetrieveApiResponse,
        AppSchedulingMeetingTemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-templates/${queryArg}/`,
        }),
        providesTags: ["MeetingTemplateViewset"],
      }),
      appSchedulingMeetingTemplatesUpdate: build.mutation<
        AppSchedulingMeetingTemplatesUpdateApiResponse,
        AppSchedulingMeetingTemplatesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-templates/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.meetingTemplateRequest,
        }),
        invalidatesTags: ["MeetingTemplateViewset"],
      }),
      appSchedulingMeetingTemplatesPartialUpdate: build.mutation<
        AppSchedulingMeetingTemplatesPartialUpdateApiResponse,
        AppSchedulingMeetingTemplatesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-templates/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedMeetingTemplate,
        }),
        invalidatesTags: ["MeetingTemplateViewset"],
      }),
      appSchedulingMeetingTemplatesDestroy: build.mutation<
        AppSchedulingMeetingTemplatesDestroyApiResponse,
        AppSchedulingMeetingTemplatesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meeting-templates/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["MeetingTemplateViewset"],
      }),
      appSchedulingMeetingsList: build.query<
        AppSchedulingMeetingsListApiResponse,
        AppSchedulingMeetingsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["Meeting"],
      }),
      appSchedulingMeetingsCreate: build.mutation<
        AppSchedulingMeetingsCreateApiResponse,
        AppSchedulingMeetingsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["Meeting"],
      }),
      appSchedulingMeetingsRetrieve: build.query<
        AppSchedulingMeetingsRetrieveApiResponse,
        AppSchedulingMeetingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/${queryArg}/`,
        }),
        providesTags: ["Meeting"],
      }),
      appSchedulingMeetingsUpdate: build.mutation<
        AppSchedulingMeetingsUpdateApiResponse,
        AppSchedulingMeetingsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.meetingRequest,
        }),
        invalidatesTags: ["Meeting"],
      }),
      appSchedulingMeetingsPartialUpdate: build.mutation<
        AppSchedulingMeetingsPartialUpdateApiResponse,
        AppSchedulingMeetingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedMeeting,
        }),
        invalidatesTags: ["Meeting"],
      }),
      appSchedulingMeetingsDestroy: build.mutation<
        AppSchedulingMeetingsDestroyApiResponse,
        AppSchedulingMeetingsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["Meeting"],
      }),
      appSchedulingMeetingsBookGroupMeetingCreate: build.mutation<
        AppSchedulingMeetingsBookGroupMeetingCreateApiResponse,
        AppSchedulingMeetingsBookGroupMeetingCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/${queryArg.id}/book-group-meeting/`,
          method: "POST",
          body: queryArg.meetingRequest,
        }),
        invalidatesTags: ["Meeting"],
      }),
      appSchedulingMeetingsDuplicateMeetingCreate: build.mutation<
        AppSchedulingMeetingsDuplicateMeetingCreateApiResponse,
        AppSchedulingMeetingsDuplicateMeetingCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/${queryArg.id}/duplicate-meeting/`,
          method: "POST",
          body: queryArg.meetingRequest,
        }),
        invalidatesTags: ["Meeting"],
      }),
      appSchedulingMeetingsSendOrgLeaderInviteCreate: build.mutation<
        AppSchedulingMeetingsSendOrgLeaderInviteCreateApiResponse,
        AppSchedulingMeetingsSendOrgLeaderInviteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/${queryArg.id}/send-org-leader-invite/`,
          method: "POST",
          body: queryArg.meetingRequest,
        }),
        invalidatesTags: ["Meeting"],
      }),
      appSchedulingMeetingsSlotsRetrieve: build.query<
        AppSchedulingMeetingsSlotsRetrieveApiResponse,
        AppSchedulingMeetingsSlotsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/${queryArg}/slots/`,
        }),
        providesTags: ["Meeting"],
      }),
      appSchedulingMeetingsBookExternalCreate: build.mutation<
        AppSchedulingMeetingsBookExternalCreateApiResponse,
        AppSchedulingMeetingsBookExternalCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/book-external`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ExternalMeeting"],
      }),
      appSchedulingMeetingsCancelExternalCreate: build.mutation<
        AppSchedulingMeetingsCancelExternalCreateApiResponse,
        AppSchedulingMeetingsCancelExternalCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/cancel-external`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ExternalMeeting"],
      }),
      appSchedulingMeetingsGetExternalRetrieve: build.query<
        AppSchedulingMeetingsGetExternalRetrieveApiResponse,
        AppSchedulingMeetingsGetExternalRetrieveApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-scheduling/meetings/get-external`,
        }),
        providesTags: ["ExternalMeeting"],
      }),
      appSchedulingMeetingsNewMeetingDefaultsRetrieve: build.query<
        AppSchedulingMeetingsNewMeetingDefaultsRetrieveApiResponse,
        AppSchedulingMeetingsNewMeetingDefaultsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/new-meeting-defaults/`,
          params: {
            leaders: queryArg,
          },
        }),
        providesTags: ["Meeting"],
      }),
      appSchedulingMeetingsRestartFromCalendarEventCreate: build.mutation<
        AppSchedulingMeetingsRestartFromCalendarEventCreateApiResponse,
        AppSchedulingMeetingsRestartFromCalendarEventCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/meetings/restart-from-calendar-event/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["Meeting"],
      }),
      appSchedulingParticipantAutocompleteRetrieve: build.query<
        AppSchedulingParticipantAutocompleteRetrieveApiResponse,
        AppSchedulingParticipantAutocompleteRetrieveApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-scheduling/participant-autocomplete/`,
        }),
        providesTags: ["api"],
      }),
      appSchedulingPinnedCalendarsList: build.query<
        AppSchedulingPinnedCalendarsListApiResponse,
        AppSchedulingPinnedCalendarsListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-scheduling/pinned-calendars/` }),
        providesTags: ["PinnedCalendar"],
      }),
      appSchedulingPinnedCalendarsCreate: build.mutation<
        AppSchedulingPinnedCalendarsCreateApiResponse,
        AppSchedulingPinnedCalendarsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/pinned-calendars/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["PinnedCalendar"],
      }),
      appSchedulingPinnedCalendarsRetrieve: build.query<
        AppSchedulingPinnedCalendarsRetrieveApiResponse,
        AppSchedulingPinnedCalendarsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/pinned-calendars/${queryArg}/`,
        }),
        providesTags: ["PinnedCalendar"],
      }),
      appSchedulingPinnedCalendarsDestroy: build.mutation<
        AppSchedulingPinnedCalendarsDestroyApiResponse,
        AppSchedulingPinnedCalendarsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/pinned-calendars/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["PinnedCalendar"],
      }),
      appSchedulingPinnedCalendarsReorderCreate: build.mutation<
        AppSchedulingPinnedCalendarsReorderCreateApiResponse,
        AppSchedulingPinnedCalendarsReorderCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/pinned-calendars/reorder/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["PinnedCalendar"],
      }),
      appSchedulingPreferencesList: build.query<
        AppSchedulingPreferencesListApiResponse,
        AppSchedulingPreferencesListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-scheduling/preferences/` }),
        providesTags: ["SchedulingPreferences"],
      }),
      appSchedulingPreferencesRetrieve: build.query<
        AppSchedulingPreferencesRetrieveApiResponse,
        AppSchedulingPreferencesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/preferences/${queryArg}/`,
        }),
        providesTags: ["SchedulingPreferences"],
      }),
      appSchedulingPreferencesUpdate: build.mutation<
        AppSchedulingPreferencesUpdateApiResponse,
        AppSchedulingPreferencesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/preferences/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.schedulingPreferencesRequest,
        }),
        invalidatesTags: ["SchedulingPreferences"],
      }),
      appSchedulingPreferencesPartialUpdate: build.mutation<
        AppSchedulingPreferencesPartialUpdateApiResponse,
        AppSchedulingPreferencesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/preferences/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedSchedulingPreferences,
        }),
        invalidatesTags: ["SchedulingPreferences"],
      }),
      appSchedulingRemoteCalendarEventsRetrieve: build.query<
        AppSchedulingRemoteCalendarEventsRetrieveApiResponse,
        AppSchedulingRemoteCalendarEventsRetrieveApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-scheduling/remote-calendar-events`,
        }),
        providesTags: ["api"],
      }),
      appSchedulingRemoteCalendarsRetrieve: build.query<
        AppSchedulingRemoteCalendarsRetrieveApiResponse,
        AppSchedulingRemoteCalendarsRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-scheduling/remote-calendars` }),
        providesTags: ["api"],
      }),
      appSchedulingRemoteCalendarsAddMsDelegateCalendarByEmailCreate:
        build.mutation<
          AppSchedulingRemoteCalendarsAddMsDelegateCalendarByEmailCreateApiResponse,
          AppSchedulingRemoteCalendarsAddMsDelegateCalendarByEmailCreateApiArg
        >({
          query: () => ({
            url: `/api/v1_15/app-scheduling/remote-calendars/add-ms-delegate-calendar-by-email`,
            method: "POST",
          }),
          invalidatesTags: ["api"],
        }),
      appSchedulingZoomContactsRetrieve: build.query<
        AppSchedulingZoomContactsRetrieveApiResponse,
        AppSchedulingZoomContactsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/zoom-contacts`,
          params: {
            search_key: queryArg,
          },
        }),
        providesTags: ["ZoomUser"],
      }),
      appSchedulingZoomSchedulersRetrieve: build.query<
        AppSchedulingZoomSchedulersRetrieveApiResponse,
        AppSchedulingZoomSchedulersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/zoom-schedulers`,
          params: {
            oauth_token_id: queryArg,
          },
        }),
        providesTags: ["ZoomUser"],
      }),
      appSchedulingZoomSettingsList: build.query<
        AppSchedulingZoomSettingsListApiResponse,
        AppSchedulingZoomSettingsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/zoom-settings/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appSchedulingZoomSettingsCreate: build.mutation<
        AppSchedulingZoomSettingsCreateApiResponse,
        AppSchedulingZoomSettingsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/zoom-settings/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingZoomSettingsRetrieve: build.query<
        AppSchedulingZoomSettingsRetrieveApiResponse,
        AppSchedulingZoomSettingsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/zoom-settings/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appSchedulingZoomSettingsUpdate: build.mutation<
        AppSchedulingZoomSettingsUpdateApiResponse,
        AppSchedulingZoomSettingsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/zoom-settings/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.zoomSettingsRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingZoomSettingsPartialUpdate: build.mutation<
        AppSchedulingZoomSettingsPartialUpdateApiResponse,
        AppSchedulingZoomSettingsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/zoom-settings/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedZoomSettings,
        }),
        invalidatesTags: ["api"],
      }),
      appSchedulingZoomUserContactsRetrieve: build.query<
        AppSchedulingZoomUserContactsRetrieveApiResponse,
        AppSchedulingZoomUserContactsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/zoom-user/contacts/`,
          params: {
            search_key: queryArg,
          },
        }),
        providesTags: ["ZoomUser"],
      }),
      appSchedulingZoomUserSchedulersRetrieve: build.query<
        AppSchedulingZoomUserSchedulersRetrieveApiResponse,
        AppSchedulingZoomUserSchedulersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-scheduling/zoom-user/schedulers/`,
          params: {
            oauth_token_id: queryArg,
          },
        }),
        providesTags: ["ZoomUser"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as schedulingApi };
export type AppSchedulingCalendarEventsListApiResponse =
  /** status 200  */ PaginatedCalendarEventList;
export type AppSchedulingCalendarEventsListApiArg = {
  /** End date for event range */
  endDate: string;
  /** Timezone for date calculations */
  forTimezone?: string;
  /** List of Google Calendar IDs */
  googleCalId?: string[];
  /** Number of results to return per page. */
  limit?: number;
  /** List of Microsoft Calendar IDs */
  msCalId?: string[];
  /** The initial index from which to return the results. */
  offset?: number;
  /** Start date for event range */
  startDate: string;
};
export type AppSchedulingCalendarEventsRetrieveApiResponse =
  /** status 200  */ CalendarEvent;
export type AppSchedulingCalendarEventsRetrieveApiArg = string;
export type AppSchedulingCalendarEventsPartialUpdateApiResponse =
  /** status 200  */ CalendarEvent;
export type AppSchedulingCalendarEventsPartialUpdateApiArg = {
  id: string;
  patchedCalendarEvent: PatchedCalendarEvent;
};
export type AppSchedulingCalendarEventsDestroyApiResponse = unknown;
export type AppSchedulingCalendarEventsDestroyApiArg = string;
export type AppSchedulingCalendarsListApiResponse =
  /** status 200  */ PaginatedCalendarList;
export type AppSchedulingCalendarsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppSchedulingCalendarsCreateApiResponse =
  /** status 201  */ Calendar;
export type AppSchedulingCalendarsCreateApiArg = CalendarRequest;
export type AppSchedulingCalendarsRetrieveApiResponse =
  /** status 200  */ Calendar;
export type AppSchedulingCalendarsRetrieveApiArg =
  /** A unique integer value identifying this calendar. */ number;
export type AppSchedulingCalendarsUpdateApiResponse =
  /** status 200  */ Calendar;
export type AppSchedulingCalendarsUpdateApiArg = {
  /** A unique integer value identifying this calendar. */
  id: number;
  calendarRequest: CalendarRequest;
};
export type AppSchedulingCalendarsPartialUpdateApiResponse =
  /** status 200  */ Calendar;
export type AppSchedulingCalendarsPartialUpdateApiArg = {
  /** A unique integer value identifying this calendar. */
  id: number;
  patchedCalendar: PatchedCalendar;
};
export type AppSchedulingCalendarsDestroyApiResponse = unknown;
export type AppSchedulingCalendarsDestroyApiArg =
  /** A unique integer value identifying this calendar. */ number;
export type AppSchedulingCalendarsBatchAssociateCreateApiResponse =
  /** status 200  */ Calendar;
export type AppSchedulingCalendarsBatchAssociateCreateApiArg = CalendarRequest;
export type AppSchedulingCalendarsGetCalendarByEmailCreateApiResponse =
  /** status 200  */ Calendar;
export type AppSchedulingCalendarsGetCalendarByEmailCreateApiArg =
  CalendarRequest;
export type AppSchedulingCalendarsSyncCalendarColorsRetrieveApiResponse =
  /** status 200  */ Calendar;
export type AppSchedulingCalendarsSyncCalendarColorsRetrieveApiArg = void;
export type AppSchedulingCalendarsUpdateAdditionalCalendarPartialUpdateApiResponse =
  /** status 200  */ Calendar;
export type AppSchedulingCalendarsUpdateAdditionalCalendarPartialUpdateApiArg =
  PatchedCalendar;
export type AppSchedulingExternalMeetingsBookExternalCreateApiResponse =
  /** status 200  */ PublicMeeting;
export type AppSchedulingExternalMeetingsBookExternalCreateApiArg =
  PublicMeetingRequest;
export type AppSchedulingExternalMeetingsCancelExternalCreateApiResponse =
  /** status 200  */ PublicMeeting;
export type AppSchedulingExternalMeetingsCancelExternalCreateApiArg =
  PublicMeetingRequest;
export type AppSchedulingExternalMeetingsGetExternalRetrieveApiResponse =
  /** status 200  */ PublicMeeting;
export type AppSchedulingExternalMeetingsGetExternalRetrieveApiArg = void;
export type AppSchedulingLeaderCalendarsListApiResponse =
  /** status 200  */ PaginatedLeaderCalendarList;
export type AppSchedulingLeaderCalendarsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppSchedulingLeaderCalendarsCreateApiResponse =
  /** status 201  */ LeaderCalendar;
export type AppSchedulingLeaderCalendarsCreateApiArg = LeaderCalendarRequest;
export type AppSchedulingLeaderCalendarsRetrieveApiResponse =
  /** status 200  */ LeaderCalendar;
export type AppSchedulingLeaderCalendarsRetrieveApiArg =
  /** A unique integer value identifying this leader calendar. */ number;
export type AppSchedulingLeaderCalendarsUpdateApiResponse =
  /** status 200  */ LeaderCalendar;
export type AppSchedulingLeaderCalendarsUpdateApiArg = {
  /** A unique integer value identifying this leader calendar. */
  id: number;
  leaderCalendarRequest: LeaderCalendarRequest;
};
export type AppSchedulingLeaderCalendarsPartialUpdateApiResponse =
  /** status 200  */ LeaderCalendar;
export type AppSchedulingLeaderCalendarsPartialUpdateApiArg = {
  /** A unique integer value identifying this leader calendar. */
  id: number;
  patchedLeaderCalendar: PatchedLeaderCalendar;
};
export type AppSchedulingLeaderCalendarsDestroyApiResponse = unknown;
export type AppSchedulingLeaderCalendarsDestroyApiArg =
  /** A unique integer value identifying this leader calendar. */ number;
export type AppSchedulingMeetingAuditLogsListApiResponse =
  /** status 200  */ PaginatedMeetingAuditLogList;
export type AppSchedulingMeetingAuditLogsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppSchedulingMeetingExternalParticipantsListApiResponse =
  /** status 200  */ PaginatedMeetingParticipantList;
export type AppSchedulingMeetingExternalParticipantsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  meetingExternalId?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  preregistered?: boolean;
};
export type AppSchedulingMeetingExternalParticipantsCreateApiResponse =
  /** status 201  */ MeetingParticipant;
export type AppSchedulingMeetingExternalParticipantsCreateApiArg =
  MeetingParticipantRequest;
export type AppSchedulingMeetingExternalParticipantsUpdateApiResponse =
  /** status 200  */ MeetingParticipant;
export type AppSchedulingMeetingExternalParticipantsUpdateApiArg = {
  /** A unique integer value identifying this meeting participant. */
  id: number;
  meetingParticipantRequest: MeetingParticipantRequest;
};
export type AppSchedulingMeetingExternalParticipantsPartialUpdateApiResponse =
  /** status 200  */ MeetingParticipant;
export type AppSchedulingMeetingExternalParticipantsPartialUpdateApiArg = {
  /** A unique integer value identifying this meeting participant. */
  id: number;
  patchedMeetingParticipant: PatchedMeetingParticipant;
};
export type AppSchedulingMeetingExternalParticipantsDestroyApiResponse =
  unknown;
export type AppSchedulingMeetingExternalParticipantsDestroyApiArg =
  /** A unique integer value identifying this meeting participant. */ number;
export type AppSchedulingMeetingExternalParticipantsNoTimesWorkCreateApiResponse =
  /** status 201  */ MeetingParticipant;
export type AppSchedulingMeetingExternalParticipantsNoTimesWorkCreateApiArg =
  MeetingParticipantRequest;
export type AppSchedulingMeetingFilesDestroyApiResponse = unknown;
export type AppSchedulingMeetingFilesDestroyApiArg = string;
export type AppSchedulingMeetingLeadersListApiResponse =
  /** status 200  */ PaginatedMeetingLeaderList;
export type AppSchedulingMeetingLeadersListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppSchedulingMeetingLeadersCreateApiResponse =
  /** status 201  */ MeetingLeader;
export type AppSchedulingMeetingLeadersCreateApiArg = MeetingLeaderRequest;
export type AppSchedulingMeetingLeadersRetrieveApiResponse =
  /** status 200  */ MeetingLeader;
export type AppSchedulingMeetingLeadersRetrieveApiArg = string;
export type AppSchedulingMeetingLeadersUpdateApiResponse =
  /** status 200  */ MeetingLeader;
export type AppSchedulingMeetingLeadersUpdateApiArg = {
  id: string;
  meetingLeaderRequest: MeetingLeaderRequest;
};
export type AppSchedulingMeetingLeadersPartialUpdateApiResponse =
  /** status 200  */ MeetingLeader;
export type AppSchedulingMeetingLeadersPartialUpdateApiArg = {
  id: string;
  patchedMeetingLeader: PatchedMeetingLeader;
};
export type AppSchedulingMeetingLeadersDestroyApiResponse = unknown;
export type AppSchedulingMeetingLeadersDestroyApiArg = string;
export type AppSchedulingMeetingLeadersBulkUpdateOrCreateCreateApiResponse =
  /** status 200  */ MeetingLeader;
export type AppSchedulingMeetingLeadersBulkUpdateOrCreateCreateApiArg =
  MeetingLeaderRequest;
export type AppSchedulingMeetingLocationPresetsListApiResponse =
  /** status 200  */ PaginatedMeetingLocationPresetList;
export type AppSchedulingMeetingLocationPresetsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppSchedulingMeetingLocationPresetsCreateApiResponse =
  /** status 201  */ MeetingLocationPreset;
export type AppSchedulingMeetingLocationPresetsCreateApiArg =
  MeetingLocationPresetRequest;
export type AppSchedulingMeetingLocationPresetsRetrieveApiResponse =
  /** status 200  */ MeetingLocationPreset;
export type AppSchedulingMeetingLocationPresetsRetrieveApiArg =
  /** A unique integer value identifying this meeting location preset. */ number;
export type AppSchedulingMeetingLocationPresetsUpdateApiResponse =
  /** status 200  */ MeetingLocationPreset;
export type AppSchedulingMeetingLocationPresetsUpdateApiArg = {
  /** A unique integer value identifying this meeting location preset. */
  id: number;
  meetingLocationPresetRequest: MeetingLocationPresetRequest;
};
export type AppSchedulingMeetingLocationPresetsPartialUpdateApiResponse =
  /** status 200  */ MeetingLocationPreset;
export type AppSchedulingMeetingLocationPresetsPartialUpdateApiArg = {
  /** A unique integer value identifying this meeting location preset. */
  id: number;
  patchedMeetingLocationPreset: PatchedMeetingLocationPreset;
};
export type AppSchedulingMeetingLocationPresetsDestroyApiResponse = unknown;
export type AppSchedulingMeetingLocationPresetsDestroyApiArg =
  /** A unique integer value identifying this meeting location preset. */ number;
export type AppSchedulingMeetingPollSelectionsListApiResponse =
  /** status 200  */ PaginatedMeetingPollSelectionList;
export type AppSchedulingMeetingPollSelectionsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppSchedulingMeetingPollSelectionsCreateApiResponse =
  /** status 201  */ MeetingPollSelection;
export type AppSchedulingMeetingPollSelectionsCreateApiArg =
  MeetingPollSelectionRequest;
export type AppSchedulingMeetingPollSelectionsBulkUpdatePollSelectionsPartialUpdateApiResponse =
  /** status 200  */ MeetingPollSelection;
export type AppSchedulingMeetingPollSelectionsBulkUpdatePollSelectionsPartialUpdateApiArg =
  PatchedMeetingPollSelection;
export type AppSchedulingMeetingPollSelectionsDeletePollSelectionsCreateApiResponse =
  /** status 200  */ MeetingPollSelection;
export type AppSchedulingMeetingPollSelectionsDeletePollSelectionsCreateApiArg =
  MeetingPollSelectionRequest;
export type AppSchedulingMeetingQuestionAnswersGetByMeetingsRetrieveApiResponse =
  /** status 200  */ MeetingQuestionAnswer;
export type AppSchedulingMeetingQuestionAnswersGetByMeetingsRetrieveApiArg =
  void;
export type AppSchedulingMeetingQuestionAnswersGetExternalMeetingAnswersRetrieveApiResponse =
  /** status 200  */ MeetingQuestionAnswer;
export type AppSchedulingMeetingQuestionAnswersGetExternalMeetingAnswersRetrieveApiArg =
  void;
export type AppSchedulingMeetingQuestionAnswersSubmitAnswersCreateApiResponse =
  /** status 200  */ MeetingQuestionAnswer;
export type AppSchedulingMeetingQuestionAnswersSubmitAnswersCreateApiArg =
  MeetingQuestionAnswerRequest;
export type AppSchedulingMeetingQuestionsCreateApiResponse =
  /** status 201  */ ReadMeetingQuestion;
export type AppSchedulingMeetingQuestionsCreateApiArg =
  ReadMeetingQuestionRequest;
export type AppSchedulingMeetingQuestionsUpdateApiResponse =
  /** status 200  */ ReadMeetingQuestion;
export type AppSchedulingMeetingQuestionsUpdateApiArg = {
  /** A unique integer value identifying this meeting question. */
  id: number;
  readMeetingQuestionRequest: ReadMeetingQuestionRequest;
};
export type AppSchedulingMeetingQuestionsPartialUpdateApiResponse =
  /** status 200  */ ReadMeetingQuestion;
export type AppSchedulingMeetingQuestionsPartialUpdateApiArg = {
  /** A unique integer value identifying this meeting question. */
  id: number;
  patchedReadMeetingQuestion: PatchedReadMeetingQuestion;
};
export type AppSchedulingMeetingQuestionsDestroyApiResponse = unknown;
export type AppSchedulingMeetingQuestionsDestroyApiArg =
  /** A unique integer value identifying this meeting question. */ number;
export type AppSchedulingMeetingQuestionsSubmitQuestionsCreateApiResponse =
  /** status 200  */ ReadMeetingQuestion;
export type AppSchedulingMeetingQuestionsSubmitQuestionsCreateApiArg =
  ReadMeetingQuestionRequest;
export type AppSchedulingMeetingRoomsListApiResponse =
  /** status 200  */ PaginatedMeetingRoomList;
export type AppSchedulingMeetingRoomsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppSchedulingMeetingSlotCalendarEventsUpdateApiResponse =
  /** status 200  */ MeetingSlotCalendarEvent;
export type AppSchedulingMeetingSlotCalendarEventsUpdateApiArg = {
  /** A unique integer value identifying this meeting slot calendar event. */
  id: number;
  meetingSlotCalendarEventRequest: MeetingSlotCalendarEventRequest;
};
export type AppSchedulingMeetingSlotCalendarEventsPartialUpdateApiResponse =
  /** status 200  */ MeetingSlotCalendarEvent;
export type AppSchedulingMeetingSlotCalendarEventsPartialUpdateApiArg = {
  /** A unique integer value identifying this meeting slot calendar event. */
  id: number;
  patchedMeetingSlotCalendarEvent: PatchedMeetingSlotCalendarEvent;
};
export type AppSchedulingMeetingSlotCalendarEventsDestroyApiResponse = unknown;
export type AppSchedulingMeetingSlotCalendarEventsDestroyApiArg =
  /** A unique integer value identifying this meeting slot calendar event. */ number;
export type AppSchedulingMeetingSlotCalendarEventsMeetingErrorsRetrieveApiResponse =
  /** status 200  */ ListMeetingErrorsResponse;
export type AppSchedulingMeetingSlotCalendarEventsMeetingErrorsRetrieveApiArg =
  {
    meetingId?: number;
    unscheduled?: number;
  };
export type AppSchedulingMeetingSlotsListApiResponse =
  /** status 200  */ PaginatedMeetingSlotList;
export type AppSchedulingMeetingSlotsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppSchedulingMeetingSlotsCreateApiResponse =
  /** status 201  */ MeetingSlot;
export type AppSchedulingMeetingSlotsCreateApiArg = MeetingSlotRequest;
export type AppSchedulingMeetingSlotsRetrieveApiResponse =
  /** status 200  */ MeetingSlot;
export type AppSchedulingMeetingSlotsRetrieveApiArg = string;
export type AppSchedulingMeetingSlotsUpdateApiResponse =
  /** status 200  */ MeetingSlot;
export type AppSchedulingMeetingSlotsUpdateApiArg = {
  id: string;
  meetingSlotRequest: MeetingSlotRequest;
};
export type AppSchedulingMeetingSlotsPartialUpdateApiResponse =
  /** status 200  */ MeetingSlot;
export type AppSchedulingMeetingSlotsPartialUpdateApiArg = {
  id: string;
  patchedMeetingSlot: PatchedMeetingSlot;
};
export type AppSchedulingMeetingSlotsDestroyApiResponse = unknown;
export type AppSchedulingMeetingSlotsDestroyApiArg = string;
export type AppSchedulingMeetingSlotsBulkCreateCreateApiResponse =
  /** status 200  */ MeetingSlot;
export type AppSchedulingMeetingSlotsBulkCreateCreateApiArg =
  MeetingSlotRequest;
export type AppSchedulingMeetingSlotsBulkDeleteDestroyApiResponse = unknown;
export type AppSchedulingMeetingSlotsBulkDeleteDestroyApiArg = void;
export type AppSchedulingMeetingTemplatesListApiResponse =
  /** status 200  */ MeetingTemplate[];
export type AppSchedulingMeetingTemplatesListApiArg = void;
export type AppSchedulingMeetingTemplatesCreateApiResponse =
  /** status 201  */ MeetingTemplate;
export type AppSchedulingMeetingTemplatesCreateApiArg = MeetingTemplateRequest;
export type AppSchedulingMeetingTemplatesRetrieveApiResponse =
  /** status 200  */ MeetingTemplate;
export type AppSchedulingMeetingTemplatesRetrieveApiArg =
  /** A unique integer value identifying this meeting template. */ number;
export type AppSchedulingMeetingTemplatesUpdateApiResponse =
  /** status 200  */ MeetingTemplate;
export type AppSchedulingMeetingTemplatesUpdateApiArg = {
  /** A unique integer value identifying this meeting template. */
  id: number;
  meetingTemplateRequest: MeetingTemplateRequest;
};
export type AppSchedulingMeetingTemplatesPartialUpdateApiResponse =
  /** status 200  */ MeetingTemplate;
export type AppSchedulingMeetingTemplatesPartialUpdateApiArg = {
  /** A unique integer value identifying this meeting template. */
  id: number;
  patchedMeetingTemplate: PatchedMeetingTemplate;
};
export type AppSchedulingMeetingTemplatesDestroyApiResponse = unknown;
export type AppSchedulingMeetingTemplatesDestroyApiArg =
  /** A unique integer value identifying this meeting template. */ number;
export type AppSchedulingMeetingsListApiResponse =
  /** status 200  */ PaginatedMeetingList;
export type AppSchedulingMeetingsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppSchedulingMeetingsCreateApiResponse = /** status 201  */ Meeting;
export type AppSchedulingMeetingsCreateApiArg = MeetingRequest;
export type AppSchedulingMeetingsRetrieveApiResponse =
  /** status 200  */ Meeting;
export type AppSchedulingMeetingsRetrieveApiArg = string;
export type AppSchedulingMeetingsUpdateApiResponse = /** status 200  */ Meeting;
export type AppSchedulingMeetingsUpdateApiArg = {
  id: string;
  meetingRequest: MeetingRequest;
};
export type AppSchedulingMeetingsPartialUpdateApiResponse =
  /** status 200  */ Meeting;
export type AppSchedulingMeetingsPartialUpdateApiArg = {
  id: string;
  patchedMeeting: PatchedMeeting;
};
export type AppSchedulingMeetingsDestroyApiResponse = unknown;
export type AppSchedulingMeetingsDestroyApiArg = string;
export type AppSchedulingMeetingsBookGroupMeetingCreateApiResponse =
  /** status 200  */ Meeting;
export type AppSchedulingMeetingsBookGroupMeetingCreateApiArg = {
  id: string;
  meetingRequest: MeetingRequest;
};
export type AppSchedulingMeetingsDuplicateMeetingCreateApiResponse =
  /** status 200  */ Meeting;
export type AppSchedulingMeetingsDuplicateMeetingCreateApiArg = {
  id: string;
  meetingRequest: MeetingRequest;
};
export type AppSchedulingMeetingsSendOrgLeaderInviteCreateApiResponse =
  /** status 200  */ Meeting;
export type AppSchedulingMeetingsSendOrgLeaderInviteCreateApiArg = {
  id: string;
  meetingRequest: MeetingRequest;
};
export type AppSchedulingMeetingsSlotsRetrieveApiResponse =
  /** status 200  */ Meeting;
export type AppSchedulingMeetingsSlotsRetrieveApiArg = string;
export type AppSchedulingMeetingsBookExternalCreateApiResponse =
  /** status 200  */ PublicMeeting;
export type AppSchedulingMeetingsBookExternalCreateApiArg =
  PublicMeetingRequest;
export type AppSchedulingMeetingsCancelExternalCreateApiResponse =
  /** status 200  */ PublicMeeting;
export type AppSchedulingMeetingsCancelExternalCreateApiArg =
  PublicMeetingRequest;
export type AppSchedulingMeetingsGetExternalRetrieveApiResponse =
  /** status 200  */ PublicMeeting;
export type AppSchedulingMeetingsGetExternalRetrieveApiArg = void;
export type AppSchedulingMeetingsNewMeetingDefaultsRetrieveApiResponse =
  /** status 200  */ NewMeetingDefaultsOutput;
export type AppSchedulingMeetingsNewMeetingDefaultsRetrieveApiArg =
  /** List of leader IDs for the meeting */ number[];
export type AppSchedulingMeetingsRestartFromCalendarEventCreateApiResponse =
  /** status 200  */ Meeting;
export type AppSchedulingMeetingsRestartFromCalendarEventCreateApiArg =
  RestartFromCalendarEventInputRequest;
export type AppSchedulingParticipantAutocompleteRetrieveApiResponse = unknown;
export type AppSchedulingParticipantAutocompleteRetrieveApiArg = void;
export type AppSchedulingPinnedCalendarsListApiResponse =
  /** status 200  */ PinnedCalendar[];
export type AppSchedulingPinnedCalendarsListApiArg = void;
export type AppSchedulingPinnedCalendarsCreateApiResponse =
  /** status 201  */ PinnedCalendar;
export type AppSchedulingPinnedCalendarsCreateApiArg = PinnedCalendarRequest;
export type AppSchedulingPinnedCalendarsRetrieveApiResponse =
  /** status 200  */ PinnedCalendar;
export type AppSchedulingPinnedCalendarsRetrieveApiArg =
  /** A unique integer value identifying this pinned calendar. */ number;
export type AppSchedulingPinnedCalendarsDestroyApiResponse = unknown;
export type AppSchedulingPinnedCalendarsDestroyApiArg =
  /** A unique integer value identifying this pinned calendar. */ number;
export type AppSchedulingPinnedCalendarsReorderCreateApiResponse =
  /** status 200  */ PinnedCalendar;
export type AppSchedulingPinnedCalendarsReorderCreateApiArg =
  PinnedCalendarRequest;
export type AppSchedulingPreferencesListApiResponse =
  /** status 200  */ SchedulingPreferencesList;
export type AppSchedulingPreferencesListApiArg = void;
export type AppSchedulingPreferencesRetrieveApiResponse =
  /** status 200  */ SchedulingPreferences;
export type AppSchedulingPreferencesRetrieveApiArg =
  /** A unique integer value identifying this scheduling preferences. */ number;
export type AppSchedulingPreferencesUpdateApiResponse =
  /** status 200  */ SchedulingPreferences;
export type AppSchedulingPreferencesUpdateApiArg = {
  /** A unique integer value identifying this scheduling preferences. */
  id: number;
  schedulingPreferencesRequest: SchedulingPreferencesRequest;
};
export type AppSchedulingPreferencesPartialUpdateApiResponse =
  /** status 200  */ SchedulingPreferences;
export type AppSchedulingPreferencesPartialUpdateApiArg = {
  /** A unique integer value identifying this scheduling preferences. */
  id: number;
  patchedSchedulingPreferences: PatchedSchedulingPreferences;
};
export type AppSchedulingRemoteCalendarEventsRetrieveApiResponse = unknown;
export type AppSchedulingRemoteCalendarEventsRetrieveApiArg = void;
export type AppSchedulingRemoteCalendarsRetrieveApiResponse = unknown;
export type AppSchedulingRemoteCalendarsRetrieveApiArg = void;
export type AppSchedulingRemoteCalendarsAddMsDelegateCalendarByEmailCreateApiResponse =
  unknown;
export type AppSchedulingRemoteCalendarsAddMsDelegateCalendarByEmailCreateApiArg =
  void;
export type AppSchedulingZoomContactsRetrieveApiResponse =
  /** status 200  */ ZoomContactsResponse;
export type AppSchedulingZoomContactsRetrieveApiArg = string | undefined;
export type AppSchedulingZoomSchedulersRetrieveApiResponse =
  /** status 200  */ ZoomSchedulersResponse;
export type AppSchedulingZoomSchedulersRetrieveApiArg =
  | (number | null)
  | undefined;
export type AppSchedulingZoomSettingsListApiResponse =
  /** status 200  */ PaginatedZoomSettingsList;
export type AppSchedulingZoomSettingsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppSchedulingZoomSettingsCreateApiResponse =
  /** status 201  */ ZoomSettings;
export type AppSchedulingZoomSettingsCreateApiArg = ZoomSettingsRequest;
export type AppSchedulingZoomSettingsRetrieveApiResponse =
  /** status 200  */ ZoomSettings;
export type AppSchedulingZoomSettingsRetrieveApiArg = string;
export type AppSchedulingZoomSettingsUpdateApiResponse =
  /** status 200  */ ZoomSettings;
export type AppSchedulingZoomSettingsUpdateApiArg = {
  id: string;
  zoomSettingsRequest: ZoomSettingsRequest;
};
export type AppSchedulingZoomSettingsPartialUpdateApiResponse =
  /** status 200  */ ZoomSettings;
export type AppSchedulingZoomSettingsPartialUpdateApiArg = {
  id: string;
  patchedZoomSettings: PatchedZoomSettings;
};
export type AppSchedulingZoomUserContactsRetrieveApiResponse =
  /** status 200  */ ZoomContactsResponse;
export type AppSchedulingZoomUserContactsRetrieveApiArg = string | undefined;
export type AppSchedulingZoomUserSchedulersRetrieveApiResponse =
  /** status 200  */ ZoomSchedulersResponse;
export type AppSchedulingZoomUserSchedulersRetrieveApiArg =
  | (number | null)
  | undefined;
export type EventAttendee = {
  /** Attendee email address */
  email: string | null;
  /** Attendee name or display name */
  name: string;
  /** Display name (Google) */
  displayName?: string;
  /** Response status
    
    * `none` - None
    * `needsAction` - Needs Action
    * `declined` - Declined
    * `tentative` - Tentative
    * `accepted` - Accepted */
  responseStatus?:
    | "none"
    | "needsAction"
    | "declined"
    | "tentative"
    | "accepted";
  /** Whether this is the current user */
  self?: boolean;
  /** Whether email is valid */
  email_valid?: boolean;
  /** Contact type ID */
  contact_type_id?: number;
  /** Whether attendance is optional */
  optional: boolean;
};
export type CalendarAccess = {
  /** Calendar access ID */
  id: number;
  /** Whether user can edit events */
  can_edit: boolean;
  /** Whether user can read private events */
  can_read_private: boolean;
  /** Calendar access roles */
  access_role:
    | (
        | "none"
        | "free_busy"
        | "limited_reader"
        | "reader"
        | "reader_private"
        | "writer"
        | "delegate_not_private_writer"
        | "delegate_private_writer"
        | "owner"
        | "custom"
      )[]
    | null;
  /** Whether this is a direct share */
  is_direct_share: boolean;
  /** Auto background color */
  auto_background_color: string;
  /** Override background color */
  override_background_color: string | null;
  /** Auto foreground color */
  auto_foreground_color: string;
  /** Override foreground color */
  override_foreground_color: string | null;
};
export type LeaderCalendar = {
  calendar: number;
  prevent_conflict?: boolean;
  allow_calendar_analytics?: boolean;
  allow_crm?: boolean;
};
export type Leader = {
  id: number;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  company?: string | null;
  primary_assistant?: number | null;
  industry?: number | null;
  industry_display: string;
  role?: string | null;
  pic_url?: string | null;
  country?: number | null;
  country_code: string;
  location_display: string;
  postal_code?: string | null;
  state?: string | null;
  state_short?: string | null;
  city?: string | null;
  phone_number?: string | null;
  custom?: any;
  color?: string;
  order: number;
  leader_calendars?: LeaderCalendar[];
  organization?: number | null;
};
export type EventLocation = {
  /** Location name */
  name: string;
  /** Location email (for resources) */
  email?: string;
};
export type CalendarEvent = {
  /** Calendar access levels */
  access_level: string[];
  /** Whether the event is all-day */
  all_day: boolean;
  /** Event attendees */
  attendees: EventAttendee[];
  /** Event background color */
  background_color: string | null;
  /** Buffer time after event in minutes */
  buffer_end_minutes: number | null;
  /** Buffer time before event in minutes */
  buffer_start_minutes: number | null;
  /** Whether the event shows as busy */
  busy: boolean;
  /** Calendar access information */
  calendar_access: CalendarAccess | null;
  /** Primary key of the calendar */
  calendar_primary_key: number | null;
  /** Calendar ID */
  calendar_id: string;
  /** Event categories */
  categories: string[] | null;
  /** Event creation time */
  create_time: string | null;
  /** iCal UID */
  icaluid: string;
  /** Event ID */
  id: string;
  /** Whether the event is canceled */
  is_canceled: boolean | null;
  /** Whether the event is a draft */
  is_draft: boolean | null;
  /** Event leaders */
  leaders: Leader[] | null;
  /** Event locations and conferences */
  locations_and_conferences: {
    [key: string]: EventLocation;
  };
  /** Original start time */
  original_start_time: string | null;
  /** Provider ID (1=Google, 2=Microsoft) */
  provider: number;
  /** Recurring root event ID */
  recurring_root_event_idr: string | null;
  /** Self response status
    
    * `none` - None
    * `needsAction` - Needs Action
    * `declined` - Declined
    * `tentative` - Tentative
    * `accepted` - Accepted */
  self_response: "none" | "needsAction" | "declined" | "tentative" | "accepted";
  /** Event sensitivity */
  sensitivity: string;
  /** Series master ID */
  series_master_id: string | null;
  /** Event start date/time */
  start: string | null;
  /** Event end date/time */
  end: string | null;
  /** Event status */
  status: string | null;
  /** Event title */
  title: string;
  /** Unique event ID */
  unique_id: string;
  /** Base64-encoded JSON string of event_id, calendar_id, and provider_id */
  lookup_key: string;
};
export type PaginatedCalendarEventList = {
  data: CalendarEvent[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type PatchedCalendarEvent = {
  /** Event start date/time */
  start?: string | null;
  /** Event end date/time */
  end?: string | null;
  /** Event status */
  status?: string | null;
  /** Event title */
  title?: string;
};
export type AnalyticsEventColor = {
  id?: number;
  color?: string | null;
  organization: number;
  category?: string | null;
  calendar: number;
  event_category?: number | null;
  event_type?: number | null;
};
export type Calendar = {
  id: number;
  calendar_id: string;
  calendar_name: string | null;
  leaders: number[];
  provider: number;
  readable: string;
  can_edit: string;
  free_busy: string;
  additional_calendar_email: string;
  is_owner_primary: boolean;
  delegator_user: string;
  owner_email: string | null;
  conference_solutions: string[];
  auto_background_color: string;
  override_background_color: string | null;
  auto_foreground_color: string;
  override_foreground_color: string | null;
  calendar_access_id: string;
  default_hold_color: AnalyticsEventColor | null;
  default_event_color: AnalyticsEventColor | null;
};
export type PaginatedCalendarList = {
  data: Calendar[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type AnalyticsEventColorRequest = {
  id?: number;
  color?: string | null;
  organization: number;
  category?: string | null;
  calendar: number;
  event_category?: number | null;
  event_type?: number | null;
};
export type CalendarRequest = {
  override_background_color: string | null;
  override_foreground_color: string | null;
  default_hold_color: AnalyticsEventColorRequest | null;
  default_event_color: AnalyticsEventColorRequest | null;
};
export type PatchedCalendar = {
  override_background_color?: string | null;
  override_foreground_color?: string | null;
  default_hold_color?: AnalyticsEventColorRequest | null;
  default_event_color?: AnalyticsEventColorRequest | null;
};
export type PublicLeader = {
  id: number;
  first_name: string | null;
  last_name: string | null;
  pic_url: string | null;
  color: string;
  role: string | null;
};
export type PublicMeetingLeader = {
  id: number;
  meeting_leader_id: number;
  first_name: string;
  last_name: string;
  pic_url: string;
  color: string;
  required: boolean;
  prevent_conflicts: boolean;
  view_calendar: boolean;
  should_invite: boolean;
  allow_poll_voting: boolean;
};
export type MeetingStatus = {
  id: number;
  name: string | null;
};
export type BookingContactOrganization = {
  name: string | null;
  logo: string | null;
};
export type BookingContactOrganizationLicense = {
  organization: BookingContactOrganization;
};
export type BookingContact = {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  active_license: BookingContactOrganizationLicense;
};
export type PublicMeetingPollSelection = {
  id: number;
  participant: number | null;
  meeting_leader: number | null;
  start_date: string;
  end_date: string;
  create_date: string;
  /** * `1` - Available
   * `2` - Potential */
  priority: 1 | 2;
  note: string | null;
};
export type ReadMeetingQuestionOption = {
  id: number;
  question: number;
  name?: string | null;
};
export type PublicMeetingQuestion = {
  id: number;
  title?: string | null;
  per_timeslot?: boolean;
  required?: boolean;
  /** * `1` - Text
   * `2` - Single-Select
   * `3` - Multi-Select */
  question_type?: 1 | 2 | 3;
  order?: number;
  options: ReadMeetingQuestionOption[];
};
export type PublicConferenceType = {
  id: number;
  name: string;
  provider: number;
};
export type GoogleMeetConferenceSettings = {
  notes?: string | null;
};
export type MsTeamsConferenceSettings = {
  allow_recording?: boolean;
  record_automatically?: boolean;
};
export type ConferenceContacts = {
  account_user_id: string;
  username: string;
  first_name?: string;
  last_name?: string;
};
export type ZoomMeetingConferenceSettings = {
  alternate_hosts?: ConferenceContacts[];
  /** * `none` - No automatic recording
   * `local` - Record on this computer
   * `cloud` - Record in the cloud */
  auto_recording?: "none" | "local" | "cloud";
  join_before_host?: boolean;
};
export type PublicMeetingLocations = {
  locations: string[] | null;
};
export type PublicMeeting = {
  id: number;
  external_id: string;
  title: string | null;
  title_booked?: string | null;
  use_link: boolean;
  duration_minutes: number;
  date_scheduled: string | null;
  leaders: PublicLeader[];
  leader_info: PublicMeetingLeader[];
  status: MeetingStatus;
  create_user: BookingContact;
  event_start_time: string | null;
  event_id: string | null;
  poll_selections: PublicMeetingPollSelection[];
  num_expected_participants: number | null;
  is_poll: boolean;
  description: string | null;
  description_booked?: string | null;
  show_voter_names: boolean;
  allow_add_participants: boolean;
  questions: PublicMeetingQuestion[];
  is_reusable: boolean;
  is_recurring: boolean;
  allow_reschedule_cancel: boolean;
  enable_public_attendee_list: boolean;
  start_delay_minutes: number;
  slot_time_interval: number | null;
  earliest_slot_date: string;
  meeting_organizer_override: string;
  conference_provider: number | null;
  all_day_slots: boolean;
  conference: PublicConferenceType;
  google_meet_conference_settings: GoogleMeetConferenceSettings | null;
  ms_teams_conference_settings: MsTeamsConferenceSettings | null;
  zoom_conference_settings: ZoomMeetingConferenceSettings | null;
  locations: PublicMeetingLocations;
};
export type PublicMeetingRequest = {
  title_booked?: string | null;
  description_booked?: string | null;
};
export type PaginatedLeaderCalendarList = {
  data: LeaderCalendar[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type LeaderCalendarRequest = {
  calendar: number;
  prevent_conflict?: boolean;
  allow_calendar_analytics?: boolean;
  allow_crm?: boolean;
};
export type PatchedLeaderCalendar = {
  calendar?: number;
  prevent_conflict?: boolean;
  allow_calendar_analytics?: boolean;
  allow_crm?: boolean;
};
export type AuditMeeting = {
  id: number;
  title?: string | null;
  title_booked?: string | null;
  leaders: number[];
  is_reusable?: boolean;
  create_date: string;
  status?: number;
  is_poll?: boolean;
  create_user: number;
  questions: PublicMeetingQuestion[];
};
export type MeetingAuditLog = {
  id: number;
  create_date: string;
  from_status: number;
  to_status: number;
  user?: number | null;
  meeting: AuditMeeting;
};
export type PaginatedMeetingAuditLogList = {
  data: MeetingAuditLog[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type MeetingParticipant = {
  id: number;
  meeting: number;
  name?: string | null;
  email?: string | null;
  email_hash: string;
  first_response_date: string | null;
  preregistered?: boolean;
  required?: boolean;
  no_times_comment?: string | null;
  calendar_access?: number | null;
  calendar: string;
  prevent_conflicts?: boolean;
  view_calendar?: boolean;
  should_invite?: boolean;
  is_fetchable: boolean;
  timezone?: string | null;
};
export type PaginatedMeetingParticipantList = {
  data: MeetingParticipant[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type MeetingParticipantRequest = {
  meeting: number;
  name?: string | null;
  email?: string | null;
  preregistered?: boolean;
  required?: boolean;
  no_times_comment?: string | null;
  calendar_access?: number | null;
  prevent_conflicts?: boolean;
  view_calendar?: boolean;
  should_invite?: boolean;
  timezone?: string | null;
};
export type PatchedMeetingParticipant = {
  meeting?: number;
  name?: string | null;
  email?: string | null;
  preregistered?: boolean;
  required?: boolean;
  no_times_comment?: string | null;
  calendar_access?: number | null;
  prevent_conflicts?: boolean;
  view_calendar?: boolean;
  should_invite?: boolean;
  timezone?: string | null;
};
export type MeetingLeader = {
  id: number;
  meeting?: number;
  leader: number;
  required?: boolean;
  prevent_conflicts?: boolean;
  view_calendar?: boolean;
  should_invite?: boolean;
  allow_poll_voting?: boolean;
  first_name: string;
  last_name: string;
  pic_url: string | null;
  color: string;
};
export type PaginatedMeetingLeaderList = {
  data: MeetingLeader[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type MeetingLeaderRequest = {
  meeting?: number;
  leader: number;
  required?: boolean;
  prevent_conflicts?: boolean;
  view_calendar?: boolean;
  should_invite?: boolean;
  allow_poll_voting?: boolean;
};
export type PatchedMeetingLeader = {
  meeting?: number;
  leader?: number;
  required?: boolean;
  prevent_conflicts?: boolean;
  view_calendar?: boolean;
  should_invite?: boolean;
  allow_poll_voting?: boolean;
};
export type MeetingLocationPreset = {
  id: number;
  name: string;
  location: string;
  owner_id: number;
};
export type PaginatedMeetingLocationPresetList = {
  data: MeetingLocationPreset[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type MeetingLocationPresetRequest = {
  name: string;
  location: string;
};
export type PatchedMeetingLocationPreset = {
  name?: string;
  location?: string;
};
export type MeetingPollSelection = {
  id?: number;
  meeting: number;
  participant?: number | null;
  meeting_leader?: number | null;
  start_date?: string;
  end_date?: string;
  create_date: string;
  /** * `1` - Available
   * `2` - Potential */
  priority?: 1 | 2;
  note?: string | null;
};
export type PaginatedMeetingPollSelectionList = {
  data: MeetingPollSelection[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type MeetingPollSelectionRequest = {
  id?: number;
  meeting: number;
  participant?: number | null;
  meeting_leader?: number | null;
  start_date?: string;
  end_date?: string;
  /** * `1` - Available
   * `2` - Potential */
  priority?: 1 | 2;
  note?: string | null;
};
export type PatchedMeetingPollSelection = {
  id?: number;
  meeting?: number;
  participant?: number | null;
  meeting_leader?: number | null;
  start_date?: string;
  end_date?: string;
  /** * `1` - Available
   * `2` - Potential */
  priority?: 1 | 2;
  note?: string | null;
};
export type MeetingQuestionAnswer = {
  id: number;
  question: number;
  poll_selection?: number | null;
  options?: number[] | null;
  text?: string | null;
  participant: number;
};
export type MeetingQuestionAnswerRequest = {
  question: number;
  poll_selection?: number | null;
  options?: number[] | null;
  text?: string | null;
  participant: number;
};
export type ReadMeetingQuestion = {
  id: number;
  meeting: number;
  title?: string | null;
  per_timeslot?: boolean;
  required?: boolean;
  /** * `1` - Text
   * `2` - Single-Select
   * `3` - Multi-Select */
  question_type?: 1 | 2 | 3;
  order?: number;
  answers: MeetingQuestionAnswer[];
  options: ReadMeetingQuestionOption[];
};
export type ReadMeetingQuestionOptionRequest = {
  question: number;
  name?: string | null;
};
export type ReadMeetingQuestionRequest = {
  meeting: number;
  title?: string | null;
  per_timeslot?: boolean;
  required?: boolean;
  /** * `1` - Text
   * `2` - Single-Select
   * `3` - Multi-Select */
  question_type?: 1 | 2 | 3;
  order?: number;
  options: ReadMeetingQuestionOptionRequest[];
};
export type PatchedReadMeetingQuestion = {
  meeting?: number;
  title?: string | null;
  per_timeslot?: boolean;
  required?: boolean;
  /** * `1` - Text
   * `2` - Single-Select
   * `3` - Multi-Select */
  question_type?: 1 | 2 | 3;
  order?: number;
  options?: ReadMeetingQuestionOptionRequest[];
};
export type MeetingRoom = {
  id: number;
  display_name: string;
  capacity: number | null;
  room_id: string;
  provider: number | null;
  email: string;
};
export type PaginatedMeetingRoomList = {
  data: MeetingRoom[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type MeetingSlot = {
  id: number;
  meeting: number;
  start_date: string;
  end_date: string;
  is_exclude?: boolean;
  all_day?: boolean;
  recurrence_rule?: any | null;
};
export type MeetingSlotCalendarEvent = {
  id: number;
  event_errors: any | null;
  meeting_slot: MeetingSlot;
  calendar_association: Calendar;
  meeting_title: string;
};
export type MeetingSlotCalendarEventRequest = {
  event_errors: any | null;
};
export type PatchedMeetingSlotCalendarEvent = {
  event_errors?: any | null;
};
export type ListMeetingErrorsResponse = {
  errors: {
    [key: string]: {
      [key: string]: any;
    }[];
  };
};
export type PaginatedMeetingSlotList = {
  data: MeetingSlot[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type MeetingSlotRequest = {
  meeting: number;
  start_date: string;
  end_date: string;
  is_exclude?: boolean;
  all_day?: boolean;
  recurrence_rule?: any | null;
};
export type PatchedMeetingSlot = {
  meeting?: number;
  start_date?: string;
  end_date?: string;
  is_exclude?: boolean;
  all_day?: boolean;
  recurrence_rule?: any | null;
};
export type MeetingTemplate = {
  id: number;
  name: string;
  title?: string;
  description?: string;
  owner_id: number;
  created_at: string;
  updated_at: string;
};
export type MeetingTemplateRequest = {
  name: string;
  title?: string;
  description?: string;
};
export type PatchedMeetingTemplate = {
  name?: string;
  title?: string;
  description?: string;
};
export type CreateUser = {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
};
export type ConferenceType = {
  name: string;
  provider: number;
};
export type RRule = {
  freq: string;
  byweekday: number;
  time: string;
};
export type RecurringDay = {
  rrule: RRule;
  duration: number;
};
export type Rules = {
  rules: RecurringDay[];
  enabled: boolean;
};
export type RecurringDays = {
  mon: Rules;
  tue: Rules;
  wed: Rules;
  thu: Rules;
  fri: Rules;
  sat: Rules;
  sun: Rules;
};
export type DateRange = {
  start: string;
  end: string;
};
export type RecurringLimit = {
  selected: string | null;
  num_days: number;
  date_range: DateRange;
};
export type RecurringOptions = {
  limit: RecurringLimit;
};
export type RecurringTimes = {
  days: RecurringDays;
  options: RecurringOptions;
};
export type MeetingFile = {
  id?: number;
  file: string;
  filename: string;
  created: string;
  updated: string;
  created_by: number;
};
export type MeetingParticipantForMeeting = {
  id: number;
  meeting?: number | null;
  name?: string | null;
  email?: string | null;
  email_hash: string;
  first_response_date: string | null;
  preregistered?: boolean;
  required?: boolean;
  no_times_comment?: string | null;
  calendar_access?: number | null;
  calendar: string;
  prevent_conflicts?: boolean;
  view_calendar?: boolean;
  should_invite?: boolean;
  is_fetchable: boolean;
  timezone?: string | null;
};
export type Meeting = {
  id: number;
  external_id?: string;
  leaders: number[];
  title?: string | null;
  title_booked?: string | null;
  internal_label?: string | null;
  calendar_tz?: string | null;
  secondary_tz?: (string | null)[] | null;
  copy_tz?: string | null;
  secondary_copy_tz?: (string | null)[] | null;
  use_link?: boolean;
  duration_minutes?: number;
  date_scheduled?: string | null;
  create_date: string;
  status?: number;
  status_data: MeetingStatus;
  locations?: string[] | null;
  locations_booked?: string[] | null;
  booking_calendar?: number | null;
  booking_color?: AnalyticsEventColor | null;
  conference_provider?: number | null;
  conference_leader?: number | null;
  google_meet_conference_settings?: GoogleMeetConferenceSettings | null;
  ms_teams_conference_settings?: MsTeamsConferenceSettings | null;
  zoom_conference_settings?: ZoomMeetingConferenceSettings | null;
  prevent_conflict?: boolean;
  is_poll?: boolean;
  description?: string | null;
  description_booked?: string | null;
  num_expected_participants?: number | null;
  poll_selections: MeetingPollSelection[];
  event_start_time?: string | null;
  event_id?: string | null;
  executive_hold?: boolean;
  hold_calendars?: number[];
  hold_calendar_accesses?: (number | null)[];
  error_count: number;
  show_voter_names?: boolean;
  allow_add_participants?: boolean;
  create_user: CreateUser;
  leader_info: PublicMeetingLeader[];
  questions: ReadMeetingQuestion[];
  calendar_info: Calendar;
  conference_info: ConferenceType;
  hold_calendar_info: Calendar[];
  rooms?: number[];
  rooms_data: MeetingRoom[];
  auto_merge_slots?: boolean;
  is_reusable?: boolean;
  is_recurring?: boolean;
  enable_public_attendee_list?: boolean;
  allow_reschedule_cancel?: boolean;
  location_presets?: number[];
  location_presets_data: MeetingLocationPreset[];
  /** * `9` - Low
   * `6` - Medium
   * `3` - High */
  priority?: 9 | 6 | 3;
  /** When True, booked calendar events are created with private visibility (Google) or private sensitivity (Microsoft). Requires calendar access with can_read_private. */
  private_visibility?: boolean;
  notes?: string | null;
  recurring_times?: RecurringTimes | null;
  template_parent?: number | null;
  use_template_parent?: boolean;
  start_delay_minutes?: number;
  files?: MeetingFile[];
  slot_time_interval?: number | null;
  selected_scheduled_time?: string | null;
  template_children: number[];
  participants?: MeetingParticipantForMeeting[];
  buffer_start_minutes?: number;
  buffer_end_minutes?: number;
  earliest_slot_date: string;
  send_participant_reminders?: boolean;
  participant_reminder_minutes?: number;
  follow_up_reminder_set_at?: string | null;
  follow_up_reminder_at?: string | null;
  follow_up_reminder_sent_at?: string | null;
  created_at: string;
  updated_at: string;
  book_on_create?: boolean;
  max_bookings_per_slot?: number;
  all_day_slots?: boolean;
};
export type PaginatedMeetingList = {
  data: Meeting[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type GoogleMeetConferenceSettingsRequest = {
  notes?: string | null;
};
export type MsTeamsConferenceSettingsRequest = {
  allow_recording?: boolean;
  record_automatically?: boolean;
};
export type ConferenceContactsRequest = {
  account_user_id: string;
  username: string;
  first_name?: string;
  last_name?: string;
};
export type ZoomMeetingConferenceSettingsRequest = {
  alternate_hosts?: ConferenceContactsRequest[];
  /** * `none` - No automatic recording
   * `local` - Record on this computer
   * `cloud` - Record in the cloud */
  auto_recording?: "none" | "local" | "cloud";
  join_before_host?: boolean;
};
export type RRuleRequest = {
  freq: string;
  byweekday: number;
  time: string;
};
export type RecurringDayRequest = {
  rrule: RRuleRequest;
  duration: number;
};
export type RulesRequest = {
  rules: RecurringDayRequest[];
  enabled: boolean;
};
export type RecurringDaysRequest = {
  mon: RulesRequest;
  tue: RulesRequest;
  wed: RulesRequest;
  thu: RulesRequest;
  fri: RulesRequest;
  sat: RulesRequest;
  sun: RulesRequest;
};
export type DateRangeRequest = {
  start: string;
  end: string;
};
export type RecurringLimitRequest = {
  selected: string | null;
  num_days: number;
  date_range: DateRangeRequest;
};
export type RecurringOptionsRequest = {
  limit: RecurringLimitRequest;
};
export type RecurringTimesRequest = {
  days: RecurringDaysRequest;
  options: RecurringOptionsRequest;
};
export type MeetingFileRequest = {
  id?: number;
  filename: string;
  created_by: number;
};
export type MeetingParticipantForMeetingRequest = {
  meeting?: number | null;
  name?: string | null;
  email?: string | null;
  preregistered?: boolean;
  required?: boolean;
  no_times_comment?: string | null;
  calendar_access?: number | null;
  prevent_conflicts?: boolean;
  view_calendar?: boolean;
  should_invite?: boolean;
  timezone?: string | null;
};
export type BookingSlotRequest = {
  /** ISO datetime string for slot start time */
  start: string;
  /** ISO datetime string for slot end time */
  end: string;
  /** Optional detail information for the slot */
  detail?: {
    [key: string]: any;
  } | null;
};
export type MeetingRequest = {
  external_id?: string;
  leaders: number[];
  title?: string | null;
  title_booked?: string | null;
  internal_label?: string | null;
  calendar_tz?: string | null;
  secondary_tz?: (string | null)[] | null;
  copy_tz?: string | null;
  secondary_copy_tz?: (string | null)[] | null;
  use_link?: boolean;
  duration_minutes?: number;
  date_scheduled?: string | null;
  status?: number;
  locations?: string[] | null;
  locations_booked?: string[] | null;
  booking_calendar?: number | null;
  booking_color?: AnalyticsEventColorRequest | null;
  conference_provider?: number | null;
  conference_leader?: number | null;
  google_meet_conference_settings?: GoogleMeetConferenceSettingsRequest | null;
  ms_teams_conference_settings?: MsTeamsConferenceSettingsRequest | null;
  zoom_conference_settings?: ZoomMeetingConferenceSettingsRequest | null;
  prevent_conflict?: boolean;
  is_poll?: boolean;
  description?: string | null;
  description_booked?: string | null;
  num_expected_participants?: number | null;
  event_start_time?: string | null;
  event_id?: string | null;
  executive_hold?: boolean;
  hold_calendars?: number[];
  hold_calendar_accesses?: (number | null)[];
  show_voter_names?: boolean;
  allow_add_participants?: boolean;
  rooms?: number[];
  auto_merge_slots?: boolean;
  is_reusable?: boolean;
  is_recurring?: boolean;
  enable_public_attendee_list?: boolean;
  allow_reschedule_cancel?: boolean;
  location_presets?: number[];
  /** * `9` - Low
   * `6` - Medium
   * `3` - High */
  priority?: 9 | 6 | 3;
  /** When True, booked calendar events are created with private visibility (Google) or private sensitivity (Microsoft). Requires calendar access with can_read_private. */
  private_visibility?: boolean;
  notes?: string | null;
  recurring_times?: RecurringTimesRequest | null;
  template_parent?: number | null;
  use_template_parent?: boolean;
  start_delay_minutes?: number;
  files?: MeetingFileRequest[];
  slot_time_interval?: number | null;
  selected_scheduled_time?: string | null;
  participants?: MeetingParticipantForMeetingRequest[];
  buffer_start_minutes?: number;
  buffer_end_minutes?: number;
  send_participant_reminders?: boolean;
  participant_reminder_minutes?: number;
  follow_up_reminder_at?: string | null;
  book_on_create?: boolean;
  max_bookings_per_slot?: number;
  all_day_slots?: boolean;
  slots_to_book?: BookingSlotRequest[];
};
export type PatchedMeeting = {
  external_id?: string;
  leaders?: number[];
  title?: string | null;
  title_booked?: string | null;
  internal_label?: string | null;
  calendar_tz?: string | null;
  secondary_tz?: (string | null)[] | null;
  copy_tz?: string | null;
  secondary_copy_tz?: (string | null)[] | null;
  use_link?: boolean;
  duration_minutes?: number;
  date_scheduled?: string | null;
  status?: number;
  locations?: string[] | null;
  locations_booked?: string[] | null;
  booking_calendar?: number | null;
  booking_color?: AnalyticsEventColorRequest | null;
  conference_provider?: number | null;
  conference_leader?: number | null;
  google_meet_conference_settings?: GoogleMeetConferenceSettingsRequest | null;
  ms_teams_conference_settings?: MsTeamsConferenceSettingsRequest | null;
  zoom_conference_settings?: ZoomMeetingConferenceSettingsRequest | null;
  prevent_conflict?: boolean;
  is_poll?: boolean;
  description?: string | null;
  description_booked?: string | null;
  num_expected_participants?: number | null;
  event_start_time?: string | null;
  event_id?: string | null;
  executive_hold?: boolean;
  hold_calendars?: number[];
  hold_calendar_accesses?: (number | null)[];
  show_voter_names?: boolean;
  allow_add_participants?: boolean;
  rooms?: number[];
  auto_merge_slots?: boolean;
  is_reusable?: boolean;
  is_recurring?: boolean;
  enable_public_attendee_list?: boolean;
  allow_reschedule_cancel?: boolean;
  location_presets?: number[];
  /** * `9` - Low
   * `6` - Medium
   * `3` - High */
  priority?: 9 | 6 | 3;
  /** When True, booked calendar events are created with private visibility (Google) or private sensitivity (Microsoft). Requires calendar access with can_read_private. */
  private_visibility?: boolean;
  notes?: string | null;
  recurring_times?: RecurringTimesRequest | null;
  template_parent?: number | null;
  use_template_parent?: boolean;
  start_delay_minutes?: number;
  files?: MeetingFileRequest[];
  slot_time_interval?: number | null;
  selected_scheduled_time?: string | null;
  participants?: MeetingParticipantForMeetingRequest[];
  buffer_start_minutes?: number;
  buffer_end_minutes?: number;
  send_participant_reminders?: boolean;
  participant_reminder_minutes?: number;
  follow_up_reminder_at?: string | null;
  book_on_create?: boolean;
  max_bookings_per_slot?: number;
  all_day_slots?: boolean;
  slots_to_book?: BookingSlotRequest[];
};
export type NewMeetingDefaultsOutput = {
  booking_calendar?: Calendar | null;
  conference_provider?: ConferenceType | null;
  conference_leader?: PublicLeader | null;
  location_presets?: MeetingLocationPreset[];
};
export type RestartFromCalendarEventInputRequest = {
  eventId: string;
  calendarId: string;
};
export type PinnedCalendar = {
  id: number;
  calendar_access: number;
  position?: number;
  calendar: string;
  created_at: string;
  updated_at: string;
};
export type PinnedCalendarRequest = {
  calendar_access: number;
  position?: number;
};
export type SchedulingPreferences = {
  id: number;
  booking_check_conflicts: boolean;
  default_duration_minutes: number;
  default_conference_provider: number | null;
  user: number | null;
  silence_executive_hold_notice: boolean;
  meeting_booked_in_app: boolean;
  meeting_booked_email: boolean;
  poll_response_received_in_app: boolean;
  poll_response_received_email: boolean;
  meeting_shared_in_app: boolean;
  meeting_shared_email: boolean;
  meeting_cancelled_in_app: boolean;
  meeting_cancelled_email: boolean;
  meeting_no_times_work_in_app: boolean;
  meeting_no_times_work_email: boolean;
  meeting_room_conflict_in_app: boolean;
  meeting_room_conflict_email: boolean;
  meeting_booking_failed_in_app: boolean;
  meeting_booking_failed_email: boolean;
  meeting_attachment_failed_in_app: boolean;
  meeting_attachment_failed_email: boolean;
  conference_creation_failed_in_app: boolean;
  conference_creation_failed_email: boolean;
  zoom_alternate_hosts_removed_in_app: boolean;
  zoom_alternate_hosts_removed_email: boolean;
  recurring_meeting_expiring_in_app: boolean;
  recurring_meeting_expiring_email: boolean;
  meeting_follow_up_in_app: boolean;
  meeting_follow_up_email: boolean;
  meeting_holds_busy: boolean;
  multi_timezone: boolean;
  granular_time_selection: boolean;
  default_calendar_timezone: string | null;
  default_secondary_timezone: (string | null)[] | null;
  hide_promo_text: boolean;
  allow_reschedule_cancel: boolean;
  show_questions_in_body: boolean;
  default_start_delay_minutes: number;
  default_slot_time_interval: number | null;
  default_location_presets: number[];
  default_condense_slots: boolean;
  /** * `INTERNAL_LABEL` - Internal Label
   * `EVENT_TITLE` - Event Title */
  event_title_for_holds: "INTERNAL_LABEL" | "EVENT_TITLE";
  default_buffer_start_minutes: number;
  default_buffer_end_minutes: number;
  default_allow_add_participants: boolean;
  send_participant_reminders: boolean;
  default_participant_reminder_minutes: number;
  meeting_organizer_override: string | null;
  recently_used_timezones: {
    [key: string]: {
      frequency: number;
      last_used: string;
    };
  };
  /** * `INTERNAL_NOTES` - Internal Notes
   * `EVENT_DESCRIPTION` - Event Description */
  event_description_for_holds: "INTERNAL_NOTES" | "EVENT_DESCRIPTION";
  /** * `SUNDAY` - Sunday
   * `MONDAY` - Monday */
  week_start_day: ("SUNDAY" | "MONDAY" | null) | null;
  /** * `SUNDAY` - Sunday
   * `MONDAY` - Monday */
  work_week_start_day: ("SUNDAY" | "MONDAY" | null) | null;
  /** * `WORK_WEEK` - Work Week
   * `WEEK` - Week
   * `DAY` - Day */
  week_view: "WORK_WEEK" | "WEEK" | "DAY";
  condense_pending_slots: boolean;
  show_all_recurring_slots: boolean;
  show_canceled_declined_events: boolean;
  show_multi_leader_columns: boolean;
  include_links_in_times: boolean;
  include_meeting_link_in_hold: boolean;
  /** Order of columns in the One-off meeting log table (e.g., ['name', 'start_time', 'status']) */
  meeting_log_one_off_column_order: string[];
  /** Order of columns in the Reusables meeting log table */
  meeting_log_reusables_column_order: string[];
  /** Order of columns in the Polls meeting log table */
  meeting_log_polls_column_order: string[];
  /** Hidden columns in the One-off meeting log table (e.g., ['phone_number', 'location']) */
  meeting_log_one_off_hidden_columns: string[];
  /** Hidden columns in the Reusables meeting log table */
  meeting_log_reusables_hidden_columns: string[];
  /** Hidden columns in the Polls meeting log table */
  meeting_log_polls_hidden_columns: string[];
};
export type SchedulingPreferencesList = {
  user_prefs: SchedulingPreferences;
  leader_prefs: {
    [key: string]: SchedulingPreferences;
  };
};
export type SchedulingPreferencesRequest = {
  booking_check_conflicts?: boolean;
  default_duration_minutes?: number;
  default_conference_provider?: number | null;
  user?: number | null;
  silence_executive_hold_notice?: boolean;
  meeting_booked_in_app?: boolean;
  meeting_booked_email?: boolean;
  poll_response_received_in_app?: boolean;
  poll_response_received_email?: boolean;
  meeting_shared_in_app?: boolean;
  meeting_shared_email?: boolean;
  meeting_cancelled_in_app?: boolean;
  meeting_cancelled_email?: boolean;
  meeting_no_times_work_in_app?: boolean;
  meeting_no_times_work_email?: boolean;
  meeting_room_conflict_in_app?: boolean;
  meeting_room_conflict_email?: boolean;
  meeting_booking_failed_in_app?: boolean;
  meeting_booking_failed_email?: boolean;
  meeting_attachment_failed_in_app?: boolean;
  meeting_attachment_failed_email?: boolean;
  conference_creation_failed_in_app?: boolean;
  conference_creation_failed_email?: boolean;
  zoom_alternate_hosts_removed_in_app?: boolean;
  zoom_alternate_hosts_removed_email?: boolean;
  recurring_meeting_expiring_in_app?: boolean;
  recurring_meeting_expiring_email?: boolean;
  meeting_follow_up_in_app?: boolean;
  meeting_follow_up_email?: boolean;
  meeting_holds_busy?: boolean;
  multi_timezone?: boolean;
  granular_time_selection?: boolean;
  default_calendar_timezone?: string | null;
  default_secondary_timezone?: (string | null)[] | null;
  hide_promo_text?: boolean;
  allow_reschedule_cancel?: boolean;
  show_questions_in_body?: boolean;
  default_start_delay_minutes?: number;
  default_slot_time_interval?: number | null;
  default_location_presets?: number[];
  default_condense_slots?: boolean;
  /** * `INTERNAL_LABEL` - Internal Label
   * `EVENT_TITLE` - Event Title */
  event_title_for_holds?: "INTERNAL_LABEL" | "EVENT_TITLE";
  default_buffer_start_minutes?: number;
  default_buffer_end_minutes?: number;
  default_allow_add_participants?: boolean;
  send_participant_reminders?: boolean;
  default_participant_reminder_minutes?: number;
  meeting_organizer_override?: string | null;
  /** * `INTERNAL_NOTES` - Internal Notes
   * `EVENT_DESCRIPTION` - Event Description */
  event_description_for_holds?: "INTERNAL_NOTES" | "EVENT_DESCRIPTION";
  /** * `SUNDAY` - Sunday
   * `MONDAY` - Monday */
  week_start_day?: ("SUNDAY" | "MONDAY" | null) | null;
  /** * `SUNDAY` - Sunday
   * `MONDAY` - Monday */
  work_week_start_day?: ("SUNDAY" | "MONDAY" | null) | null;
  /** * `WORK_WEEK` - Work Week
   * `WEEK` - Week
   * `DAY` - Day */
  week_view?: "WORK_WEEK" | "WEEK" | "DAY";
  condense_pending_slots?: boolean;
  show_all_recurring_slots?: boolean;
  show_canceled_declined_events?: boolean;
  show_multi_leader_columns?: boolean;
  include_links_in_times?: boolean;
  include_meeting_link_in_hold?: boolean;
  /** Order of columns in the One-off meeting log table (e.g., ['name', 'start_time', 'status']) */
  meeting_log_one_off_column_order?: string[];
  /** Order of columns in the Reusables meeting log table */
  meeting_log_reusables_column_order?: string[];
  /** Order of columns in the Polls meeting log table */
  meeting_log_polls_column_order?: string[];
  /** Hidden columns in the One-off meeting log table (e.g., ['phone_number', 'location']) */
  meeting_log_one_off_hidden_columns?: string[];
  /** Hidden columns in the Reusables meeting log table */
  meeting_log_reusables_hidden_columns?: string[];
  /** Hidden columns in the Polls meeting log table */
  meeting_log_polls_hidden_columns?: string[];
};
export type PatchedSchedulingPreferences = {
  booking_check_conflicts?: boolean;
  default_duration_minutes?: number;
  default_conference_provider?: number | null;
  user?: number | null;
  silence_executive_hold_notice?: boolean;
  meeting_booked_in_app?: boolean;
  meeting_booked_email?: boolean;
  poll_response_received_in_app?: boolean;
  poll_response_received_email?: boolean;
  meeting_shared_in_app?: boolean;
  meeting_shared_email?: boolean;
  meeting_cancelled_in_app?: boolean;
  meeting_cancelled_email?: boolean;
  meeting_no_times_work_in_app?: boolean;
  meeting_no_times_work_email?: boolean;
  meeting_room_conflict_in_app?: boolean;
  meeting_room_conflict_email?: boolean;
  meeting_booking_failed_in_app?: boolean;
  meeting_booking_failed_email?: boolean;
  meeting_attachment_failed_in_app?: boolean;
  meeting_attachment_failed_email?: boolean;
  conference_creation_failed_in_app?: boolean;
  conference_creation_failed_email?: boolean;
  zoom_alternate_hosts_removed_in_app?: boolean;
  zoom_alternate_hosts_removed_email?: boolean;
  meeting_follow_up_in_app?: boolean;
  meeting_follow_up_email?: boolean;
  meeting_holds_busy?: boolean;
  multi_timezone?: boolean;
  granular_time_selection?: boolean;
  default_calendar_timezone?: string | null;
  default_secondary_timezone?: (string | null)[] | null;
  hide_promo_text?: boolean;
  allow_reschedule_cancel?: boolean;
  show_questions_in_body?: boolean;
  default_start_delay_minutes?: number;
  default_slot_time_interval?: number | null;
  default_location_presets?: number[];
  default_condense_slots?: boolean;
  /** * `INTERNAL_LABEL` - Internal Label
   * `EVENT_TITLE` - Event Title */
  event_title_for_holds?: "INTERNAL_LABEL" | "EVENT_TITLE";
  default_buffer_start_minutes?: number;
  default_buffer_end_minutes?: number;
  default_allow_add_participants?: boolean;
  send_participant_reminders?: boolean;
  default_participant_reminder_minutes?: number;
  meeting_organizer_override?: string | null;
  /** * `INTERNAL_NOTES` - Internal Notes
   * `EVENT_DESCRIPTION` - Event Description */
  event_description_for_holds?: "INTERNAL_NOTES" | "EVENT_DESCRIPTION";
  /** * `SUNDAY` - Sunday
   * `MONDAY` - Monday */
  week_start_day?: ("SUNDAY" | "MONDAY" | null) | null;
  /** * `SUNDAY` - Sunday
   * `MONDAY` - Monday */
  work_week_start_day?: ("SUNDAY" | "MONDAY" | null) | null;
  /** * `WORK_WEEK` - Work Week
   * `WEEK` - Week
   * `DAY` - Day */
  week_view?: "WORK_WEEK" | "WEEK" | "DAY";
  condense_pending_slots?: boolean;
  show_all_recurring_slots?: boolean;
  show_canceled_declined_events?: boolean;
  show_multi_leader_columns?: boolean;
  include_links_in_times?: boolean;
  include_meeting_link_in_hold?: boolean;
  /** Order of columns in the One-off meeting log table (e.g., ['name', 'start_time', 'status']) */
  meeting_log_one_off_column_order?: string[];
  /** Order of columns in the Reusables meeting log table */
  meeting_log_reusables_column_order?: string[];
  /** Order of columns in the Polls meeting log table */
  meeting_log_polls_column_order?: string[];
  /** Hidden columns in the One-off meeting log table (e.g., ['phone_number', 'location']) */
  meeting_log_one_off_hidden_columns?: string[];
  /** Hidden columns in the Reusables meeting log table */
  meeting_log_reusables_hidden_columns?: string[];
  /** Hidden columns in the Polls meeting log table */
  meeting_log_polls_hidden_columns?: string[];
};
export type ZoomUserContact = {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
};
export type ZoomContactsResponse = {
  zoom_user_contacts: ZoomUserContact[];
};
export type ZoomUserScheduler = {
  id: string;
  email: string;
};
export type ZoomSchedulersResponse = {
  zoom_user_schedulers: {
    [key: string]: {
      [key: string]: ZoomUserScheduler[];
    };
  };
  has_shared_permissions: boolean;
  has_basic_permissions: boolean;
};
export type OAuthToken = {
  id: number;
  provider: number;
  username: string;
};
export type ZoomSettings = {
  id: number;
  conference_provider: number;
  leader?: number | null;
  oauth_token: OAuthToken;
  oauth_token_id: number;
  alternate_hosts: ConferenceContacts[];
  /** * `OBO` - OBO
   * `PMI` - PMI */
  method?: "OBO" | "PMI";
  schedule_obo: ConferenceContacts | null;
  personal_meeting_link?: string | null;
};
export type PaginatedZoomSettingsList = {
  data: ZoomSettings[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type ZoomSettingsRequest = {
  leader?: number | null;
  oauth_token_id: number;
  alternate_hosts: ConferenceContactsRequest[];
  /** * `OBO` - OBO
   * `PMI` - PMI */
  method?: "OBO" | "PMI";
  schedule_obo: ConferenceContactsRequest | null;
  personal_meeting_link?: string | null;
};
export type PatchedZoomSettings = {
  leader?: number | null;
  oauth_token_id?: number;
  alternate_hosts?: ConferenceContactsRequest[];
  /** * `OBO` - OBO
   * `PMI` - PMI */
  method?: "OBO" | "PMI";
  schedule_obo?: ConferenceContactsRequest | null;
  personal_meeting_link?: string | null;
};
export const {
  useAppSchedulingCalendarEventsListQuery,
  useAppSchedulingCalendarEventsRetrieveQuery,
  useAppSchedulingCalendarEventsPartialUpdateMutation,
  useAppSchedulingCalendarEventsDestroyMutation,
  useAppSchedulingCalendarsListQuery,
  useAppSchedulingCalendarsCreateMutation,
  useAppSchedulingCalendarsRetrieveQuery,
  useAppSchedulingCalendarsUpdateMutation,
  useAppSchedulingCalendarsPartialUpdateMutation,
  useAppSchedulingCalendarsDestroyMutation,
  useAppSchedulingCalendarsBatchAssociateCreateMutation,
  useAppSchedulingCalendarsGetCalendarByEmailCreateMutation,
  useAppSchedulingCalendarsSyncCalendarColorsRetrieveQuery,
  useAppSchedulingCalendarsUpdateAdditionalCalendarPartialUpdateMutation,
  useAppSchedulingExternalMeetingsBookExternalCreateMutation,
  useAppSchedulingExternalMeetingsCancelExternalCreateMutation,
  useAppSchedulingExternalMeetingsGetExternalRetrieveQuery,
  useAppSchedulingLeaderCalendarsListQuery,
  useAppSchedulingLeaderCalendarsCreateMutation,
  useAppSchedulingLeaderCalendarsRetrieveQuery,
  useAppSchedulingLeaderCalendarsUpdateMutation,
  useAppSchedulingLeaderCalendarsPartialUpdateMutation,
  useAppSchedulingLeaderCalendarsDestroyMutation,
  useAppSchedulingMeetingAuditLogsListQuery,
  useAppSchedulingMeetingExternalParticipantsListQuery,
  useAppSchedulingMeetingExternalParticipantsCreateMutation,
  useAppSchedulingMeetingExternalParticipantsUpdateMutation,
  useAppSchedulingMeetingExternalParticipantsPartialUpdateMutation,
  useAppSchedulingMeetingExternalParticipantsDestroyMutation,
  useAppSchedulingMeetingExternalParticipantsNoTimesWorkCreateMutation,
  useAppSchedulingMeetingFilesDestroyMutation,
  useAppSchedulingMeetingLeadersListQuery,
  useAppSchedulingMeetingLeadersCreateMutation,
  useAppSchedulingMeetingLeadersRetrieveQuery,
  useAppSchedulingMeetingLeadersUpdateMutation,
  useAppSchedulingMeetingLeadersPartialUpdateMutation,
  useAppSchedulingMeetingLeadersDestroyMutation,
  useAppSchedulingMeetingLeadersBulkUpdateOrCreateCreateMutation,
  useAppSchedulingMeetingLocationPresetsListQuery,
  useAppSchedulingMeetingLocationPresetsCreateMutation,
  useAppSchedulingMeetingLocationPresetsRetrieveQuery,
  useAppSchedulingMeetingLocationPresetsUpdateMutation,
  useAppSchedulingMeetingLocationPresetsPartialUpdateMutation,
  useAppSchedulingMeetingLocationPresetsDestroyMutation,
  useAppSchedulingMeetingPollSelectionsListQuery,
  useAppSchedulingMeetingPollSelectionsCreateMutation,
  useAppSchedulingMeetingPollSelectionsBulkUpdatePollSelectionsPartialUpdateMutation,
  useAppSchedulingMeetingPollSelectionsDeletePollSelectionsCreateMutation,
  useAppSchedulingMeetingQuestionAnswersGetByMeetingsRetrieveQuery,
  useAppSchedulingMeetingQuestionAnswersGetExternalMeetingAnswersRetrieveQuery,
  useAppSchedulingMeetingQuestionAnswersSubmitAnswersCreateMutation,
  useAppSchedulingMeetingQuestionsCreateMutation,
  useAppSchedulingMeetingQuestionsUpdateMutation,
  useAppSchedulingMeetingQuestionsPartialUpdateMutation,
  useAppSchedulingMeetingQuestionsDestroyMutation,
  useAppSchedulingMeetingQuestionsSubmitQuestionsCreateMutation,
  useAppSchedulingMeetingRoomsListQuery,
  useAppSchedulingMeetingSlotCalendarEventsUpdateMutation,
  useAppSchedulingMeetingSlotCalendarEventsPartialUpdateMutation,
  useAppSchedulingMeetingSlotCalendarEventsDestroyMutation,
  useAppSchedulingMeetingSlotCalendarEventsMeetingErrorsRetrieveQuery,
  useAppSchedulingMeetingSlotsListQuery,
  useAppSchedulingMeetingSlotsCreateMutation,
  useAppSchedulingMeetingSlotsRetrieveQuery,
  useAppSchedulingMeetingSlotsUpdateMutation,
  useAppSchedulingMeetingSlotsPartialUpdateMutation,
  useAppSchedulingMeetingSlotsDestroyMutation,
  useAppSchedulingMeetingSlotsBulkCreateCreateMutation,
  useAppSchedulingMeetingSlotsBulkDeleteDestroyMutation,
  useAppSchedulingMeetingTemplatesListQuery,
  useAppSchedulingMeetingTemplatesCreateMutation,
  useAppSchedulingMeetingTemplatesRetrieveQuery,
  useAppSchedulingMeetingTemplatesUpdateMutation,
  useAppSchedulingMeetingTemplatesPartialUpdateMutation,
  useAppSchedulingMeetingTemplatesDestroyMutation,
  useAppSchedulingMeetingsListQuery,
  useAppSchedulingMeetingsCreateMutation,
  useAppSchedulingMeetingsRetrieveQuery,
  useAppSchedulingMeetingsUpdateMutation,
  useAppSchedulingMeetingsPartialUpdateMutation,
  useAppSchedulingMeetingsDestroyMutation,
  useAppSchedulingMeetingsBookGroupMeetingCreateMutation,
  useAppSchedulingMeetingsDuplicateMeetingCreateMutation,
  useAppSchedulingMeetingsSendOrgLeaderInviteCreateMutation,
  useAppSchedulingMeetingsSlotsRetrieveQuery,
  useAppSchedulingMeetingsBookExternalCreateMutation,
  useAppSchedulingMeetingsCancelExternalCreateMutation,
  useAppSchedulingMeetingsGetExternalRetrieveQuery,
  useAppSchedulingMeetingsNewMeetingDefaultsRetrieveQuery,
  useAppSchedulingMeetingsRestartFromCalendarEventCreateMutation,
  useAppSchedulingParticipantAutocompleteRetrieveQuery,
  useAppSchedulingPinnedCalendarsListQuery,
  useAppSchedulingPinnedCalendarsCreateMutation,
  useAppSchedulingPinnedCalendarsRetrieveQuery,
  useAppSchedulingPinnedCalendarsDestroyMutation,
  useAppSchedulingPinnedCalendarsReorderCreateMutation,
  useAppSchedulingPreferencesListQuery,
  useAppSchedulingPreferencesRetrieveQuery,
  useAppSchedulingPreferencesUpdateMutation,
  useAppSchedulingPreferencesPartialUpdateMutation,
  useAppSchedulingRemoteCalendarEventsRetrieveQuery,
  useAppSchedulingRemoteCalendarsRetrieveQuery,
  useAppSchedulingRemoteCalendarsAddMsDelegateCalendarByEmailCreateMutation,
  useAppSchedulingZoomContactsRetrieveQuery,
  useAppSchedulingZoomSchedulersRetrieveQuery,
  useAppSchedulingZoomSettingsListQuery,
  useAppSchedulingZoomSettingsCreateMutation,
  useAppSchedulingZoomSettingsRetrieveQuery,
  useAppSchedulingZoomSettingsUpdateMutation,
  useAppSchedulingZoomSettingsPartialUpdateMutation,
  useAppSchedulingZoomUserContactsRetrieveQuery,
  useAppSchedulingZoomUserSchedulersRetrieveQuery,
} = injectedRtkApi;
